const adminTranslations = {
  it: {
    // general
    loading: "Caricamento...",
    unknownError: "Errore sconosciuto",
    save: "Salva",
    saving: "Salvataggio...",
    cancel: "Annulla",
    delete: "Elimina",
    deleting: "Eliminando...",
    edit: "Modifica",
    confirm: "Conferma",
    back: "Indietro",
    continua: "Continua",
    open: "Apri",
    copy: "Copia",
    copied: "Copiato",
    update: "Aggiorna",
    close: "Chiudi",
    yes: "Sì",
    no: "No",
    // time slots
    fullDay: "Giornata intera",
    morning: "Mattina",
    afternoon: "Pomeriggio",
    sunset: "Tramonto",
    // booking statuses
    statusPending: "In attesa",
    statusAccepted: "Accettato",
    statusAwaitingPayment: "Att. pagamento",
    statusConfirmed: "Confermato",
    statusCompleted: "Completato",
    statusCancelled: "Annullato",
    statusConfirmedBadge: "Confermata",
    statusPendingBadge: "In attesa",
    statusPaidBadge: "Pagato ✓",
    statusConfirmedDeposit: "Confermato · acconto",
    // payment statuses
    payUnpaid: "Non Pagato",
    payPartialDeposit: "Acconto Parziale",
    payDepositReceived: "Acconto Ricevuto",
    payFullyPaid: "Saldato",
    payRefunded: "Rimborsato",
    payUnpaidShort: "Non pagato",
    payDepositReceivedShort: "Acconto ricevuto",
    payPartialDepositShort: "Acconto parziale",
    payPaid: "Pagato",
    // payment methods
    pmCash: "Contanti",
    pmBankTransfer: "Bonifico",
    pmDebitCard: "Bancomat",
    pmCard: "Carta",
    pmLink: "Link",
    pmStripe: "Stripe",
    pmPaymentLink: "Link pagamento",
    pmOther: "Altro",
    // booking sources
    sourceManual: "Manuale",
    sourceWebsite: "Sito web",
    sourcePhone: "Telefono",
    sourceWhatsApp: "WhatsApp",
    sourceAgency: "Agenzia",
    sourceWeb: "Web",
    sourceApp: "App",
    // booking types
    typeGroup: "Tour in gruppo",
    typeExclusive: "Tour esclusiva",
    typeRental: "Locazione",
    typeGroupShort: "Gruppo",
    typeExclusiveShort: "Esclusiva",
    // login
    loginSubtitle: "Accedi al tuo account",
    emailPlaceholder: "email@esempio.com",
    rememberMe: "Ricordati di me",
    signingIn: "Accesso...",
    signIn: "Accedi",
    noAccount: "Non hai un account?",
    registerFree: "Registrati gratis",
    backToHome: "← Torna alla home",
    // sidebar/layout
    charterMgmt: "Gestione Charter",
    navCalendar: "Calendario",
    navBookings: "Prenotazioni",
    navBoats: "Barche",
    navRevenue: "Fatturato",
    navSettings: "Impostazioni",
    navAccount: "Account",
    userFallback: "Utente",
    logout: "Esci",
    // dashboard
    greetingMorning: "Buongiorno",
    greetingAfternoon: "Buon pomeriggio",
    greetingEvening: "Buonasera",
    charterFallback: "Il tuo Charter",
    expiredTitle: "Accesso limitato",
    expiredMessage: "Il tuo trial è scaduto. Attiva l'abbonamento per riprendere l'accesso completo.",
    activateNow: "Attiva ora",
    paymentIssueTitle: "Problema di pagamento",
    paymentIssueMessage: "Aggiorna il metodo di pagamento per mantenere l'accesso.",
    manage: "Gestisci",
    todayLabel: "Oggi",
    toConfirm: "da confermare",
    unpaidLabel: "non pagati",
    bookingsToday: "Prenotazioni oggi",
    confirmedCount: "confermate",
    fleetToday: "Flotta oggi",
    available: "disponibili",
    occupied: "occupate",
    pendingRequests: "Richieste in attesa",
    viewAll: "Visualizza tutte →",
    bookingLink: "Link di prenotazione",
    todaysBookings: "Prenotazioni di oggi",
    noBookingsToday: "Nessuna prenotazione oggi",
    groupTour: "Tour in gruppo",
    bookingsSuffix: "pren.",
    personsSuffix: "pers.",
    multiDayUntil: "Multi-giorno: fino al",
    dayLabel: "giorno",
    daysLabel: "giorni",
    // weather widget
    weatherTitle: "Meteo",
    weatherRefresh: "Aggiorna",
    weatherLoading: "Caricamento previsioni…",
    weatherUnavailable: "Previsioni non disponibili",
    weatherTomorrow: "Domani",
    weatherClear: "Sereno",
    weatherPartlyCloudy: "Poco nuvoloso",
    weatherCloudy: "Nuvoloso",
    weatherFog: "Nebbia",
    weatherDrizzle: "Pioggerella",
    weatherRain: "Pioggia",
    weatherSnow: "Neve",
    weatherShowers: "Rovesci",
    weatherSnowWind: "Neve e vento",
    weatherStorm: "Temporale",
    weatherFullWeek: "Settimana completa →",
    weather7Days: "Previsioni 7 giorni",
    // booking detail modal
    guestFallback: "Cliente",
    fieldDate: "Data",
    fieldTimeSlot: "Fascia oraria",
    fieldBoat: "Barca",
    fieldGuests: "Persone",
    customerNotes: "Note cliente:",
    internalNotes: "Note interne:",
    fieldTotal: "Totale",
    fieldDeposit: "Acconto rich.",
    fieldCollected: "Incassato",
    fieldRemaining: "Rimanente",
    addPayment: "Registra pagamento",
    paymentType: "Tipo",
    paymentAmount: "Importo €",
    paymentMethod: "Metodo",
    paymentTypeDeposit: "Acconto",
    paymentTypeBalance: "Saldo",
    paymentNotes: "Note (opzionale)",
    savePayment: "Salva pagamento",
    paymentHistory: "Cronologia pagamenti",
    editBooking: "Modifica prenotazione",
    fieldPriceLabel: "Prezzo €",
    fieldDepositLabel: "Acconto richiesto €",
    internalNotesPlaceholder: "Note interne",
    saveChanges: "Salva modifiche",
    confirmDelete: "Conferma eliminazione",
    deleteBooking: "Elimina prenotazione",
    noPermission: "Non hai i permessi per questa operazione",
    saveError: "Errore durante il salvataggio",
    invalidAmount: "Inserisci un importo valido maggiore di zero",
    invalidGuests: "Numero di persone non valido",
    invalidPrice: "Prezzo non valido",
    invalidDeposit: "Acconto non valido",
    depositExceedsTotal: "L'acconto richiesto non può superare il prezzo totale",
    deletePaymentError: "Errore durante l'eliminazione del pagamento",
    // prenotazioni page
    searchPlaceholder: "Cerca cliente, barca...",
    filterAll: "Tutte",
    filterUpcoming: "Prossime",
    filterPast: "Passate",
    listView: "Lista",
    calendarView: "Calendario",
    accept: "Accetta",
    reject: "Rifiuta",
    complete: "Completata",
    noContact: "Nessun contatto",
    noBookingsFound: "Nessuna prenotazione trovata",
    // richieste page
    requestsTitle: "Richieste",
    noRequestsPending: "Nessuna richiesta in attesa",
    newRequest: "Nuova richiesta",
    // barche page
    boatsTitle: "Barche",
    addBoat: "Aggiungi barca",
    onlyActiveBoats: "Solo barche attive",
    noBoats: "Nessuna barca ancora",
    addFirstBoat: "Aggiungi la tua prima barca per iniziare",
    boatActive: "ATTIVA",
    boatInactive: "INATTIVA",
    deactivate: "Disattiva",
    activate: "Attiva",
    deleteBoat: "Elimina barca",
    deleteBoatConfirm: "Sei sicuro di voler eliminare",
    deleteBoatIrreversible: "Questa azione non è reversibile.",
    // boat form modal
    editBoat: "Modifica barca",
    newBoat: "Nuova barca",
    sectionBase: "Info base",
    sectionModes: "Modalità",
    sectionSlots: "Fasce orarie",
    sectionPayment: "Pagamento",
    sectionSeasonal: "Stagionale",
    boatPhoto: "Foto barca",
    photoUploading: "Caricamento...",
    choosePhoto: "Scegli foto",
    removePhoto: "Rimuovi",
    boatName: "Nome barca *",
    boatNameRequired: "Nome obbligatorio",
    boatModel: "Modello",
    boatCapacity: "Capacità massima *",
    boatCapacityRequired: "Inserisci una capacità valida",
    boatPort: "Porto di partenza *",
    boatPortRequired: "Porto di partenza obbligatorio",
    boatWeatherZone: "Zona meteo",
    boatWeatherZoneOptional: "(opzionale)",
    boatWeatherZoneHint: "Solo se le previsioni meteo non funzionano per il porto indicato",
    boatNotes: "Note interne",
    boatNotesPlaceholder: "Note visibili solo a te...",
    boatShowNotesPublic: "Mostra note ai clienti nella pagina pubblica",
    boatIsActive: "Barca attiva",
    boatIsActiveDesc: "Se disattivata non appare nella pagina pubblica",
    modesSelectAtLeast: "Seleziona almeno una modalità di booking",
    modesHint: "Seleziona almeno una modalità. Puoi abilitarne più di una sulla stessa barca.",
    tourGroupLabel: "Tour in Gruppo",
    tourGroupDesc: "Prezzo a persona, più clienti per escursione",
    tourExclusiveLabel: "Tour Esclusiva",
    tourExclusiveDesc: "Prezzo fisso per la barca intera",
    tourRentalLabel: "Locazione",
    tourRentalDesc: "Noleggio senza equipaggio",
    pricePerPerson: "Prezzo a persona (€)",
    priceHalfDay: "Mezza giornata (€)",
    priceFullDay: "Giornata intera (€)",
    priceSunset: "Tramonto (€)",
    skipperAvailable: "Skipper disponibile",
    skipperMode: "Modalità skipper",
    skipperOnRequest: "Su richiesta",
    skipperAlwaysIncluded: "Sempre incluso",
    skipperPrice: "Prezzo giornaliero skipper (€)",
    multiDayEnabled: "Abilita noleggio multi-giorno",
    multiDayMin: "Durata minima (giorni)",
    multiDayMax: "Durata massima (giorni, vuoto = illimitato)",
    bookingMode: "Modalità prenotazione",
    bookingModeRequest: "Su richiesta (tu confermi)",
    bookingModeInstant: "Immediata (auto-confermata)",
    paymentType: "Tipo pagamento",
    paymentFull: "Pagamento completo",
    paymentDeposit: "Solo acconto",
    depositPercent: "% acconto richiesto",
    seasonalPricing: "Prezzi stagionali",
    addSeasonalRule: "Aggiungi regola",
    seasonalRuleName: "Nome stagione",
    seasonalFrom: "Dal",
    seasonalTo: "Al",
    seasonalSave: "Salva regola",
    // fatturato page
    revenueTitle: "Fatturato",
    exportCSV: "Esporta CSV",
    periodDay: "Giorno",
    periodWeek: "Settimana",
    periodMonth: "Mese",
    periodYear: "Anno",
    typeGroupTourLabel: "Tour in Gruppo",
    typeExclusiveTourLabel: "Tour Esclusiva",
    typeRentalLabel: "Noleggio",
    typeOtherLabel: "Altro",
    boatUnknown: "Sconosciuta",
    csvDate: "Data",
    csvBoat: "Barca",
    csvCustomer: "Cliente",
    csvType: "Tipo",
    csvTotal: "Totale",
    csvDeposit: "Acconto",
    csvBalance: "Saldo",
    csvPaymentStatus: "Stato pagamento",
    revenueByType: "Riepilogo per Tipologia",
    revenueByBoat: "Fatturato per Unità Navale",
    revenueBookings: "prenotazioni",
    revenueCollected: "Incassato",
    revenueTotal: "Totale",
    revenueOfTotal: "del totale",
    revenueGuests: "ospiti",
    revenueDeposits: "Acconti",
    revenueRemaining: "Residuo",
    csvExportError: "Errore durante l'esportazione",
    // profilo/settings page
    settingsTitle: "Impostazioni",
    settingsSubtitle: "Profilo, pagamenti, prenotazioni online e notifiche.",
    tabProfile: "Profilo",
    tabBookings: "Prenotazioni",
    tabPayments: "Pagamenti",
    tabNotifications: "Notifiche",
    tabWeather: "⛈ Meteo",
    profileUpdated: "Profilo aggiornato con successo.",
    saveError2: "Errore nel salvataggio.",
    logoUploadError: "Errore nel caricamento del logo.",
    logoUploading: "Caricamento",
    changeLogo: "Cambia logo",
    subscriptionActive: "Abbonamento attivo",
    subscriptionTrial: "Trial in corso",
    subscriptionExpired: "Abbonamento scaduto",
    personalData: "Dati personali",
    fieldFirstName: "Nome",
    fieldLastName: "Cognome",
    fieldEmail: "Email",
    fieldPhone: "Telefono",
    companyData: "Dati azienda",
    companyName: "Nome attività",
    vatNumber: "P.IVA",
    sdiCode: "Codice SDI",
    pec: "PEC",
    address: "Indirizzo",
    city: "Città",
    zip: "CAP",
    website: "Sito web",
    changePassword: "Cambia password",
    newPassword: "Nuova password",
    newPasswordPlaceholder: "Minimo 8 caratteri",
    confirmPassword: "Conferma password",
    confirmPasswordPlaceholder: "Ripeti la nuova password",
    passwordMinLength: "La nuova password deve essere di almeno 8 caratteri.",
    passwordMismatch: "Le password non coincidono.",
    passwordUpdated: "Password aggiornata.",
    passwordError: "Errore nel cambio password.",
    updatingPassword: "Aggiornamento...",
    updatePassword: "Aggiorna password",
    // online bookings tab
    publicBookingLink: "Link prenotazione pubblica",
    publicBookingLinkDesc: "Condividi questo link con i tuoi clienti. Possono vedere le tue barche e prenotare direttamente, 24/7.",
    featureNotAvailable: "Funzione non disponibile nel tuo piano",
    upgradeToEnable: "Aggiorna l'abbonamento per abilitare le prenotazioni online.",
    howToIntegrate: "Come integrare nel tuo sito",
    integrationStep1: "Copia il link qui sopra",
    integrationStep2: "Aggiungilo come pulsante \"Prenota ora\" nel tuo sito web",
    integrationStep3: "I clienti arrivano sulla pagina Nautiqo, scelgono la barca e prenotano",
    integrationStep4: "Tu ricevi la notifica e gestisci tutto dalla dashboard",
    siteWebLabel: "Sito web",
    siteWebDesc: "Inserisci il link come CTA",
    instagramLabel: "Instagram",
    instagramDesc: "Link in bio o stories",
    whatsappLabel: "WhatsApp",
    whatsappDesc: "Invia ai clienti diretti",
    copiedBang: "Copiato!",
    // payments tab
    stripeNotConfigured: "Non configurato",
    stripeVerifying: "In verifica — completa la configurazione",
    stripeActive: "Attivo · incassi abilitati",
    stripeComplete: "Completa",
    stripeConnect: "Connetti",
    stripeWaiting: "Attendere",
    stripeCharges: "Addebiti",
    stripePayouts: "Pagamenti",
    stripeCommission: "Commissione",
    stripeEnabled: "✓ Abilitati",
    stripePending: "In attesa",
    absorbFees: "Assorbi commissione +5%",
    absorbFeesDesc: "Il cliente paga il 5% in più; tu ricevi il netto",
    absorbFeesActive: "Commissione +5% attivata. I clienti vedranno il prezzo maggiorato.",
    absorbFeesInactive: "Commissione +5% disattivata.",
    cancelPolicy: "Politica di cancellazione",
    cancelPolicyDesc: "Si applica alle prenotazioni pagate con deposito online.",
    cancelPolicyFlexible: "Flessibile",
    cancelPolicyModerate: "Moderata",
    cancelPolicyStrict: "Rigida",
    cancelPolicyFlexibleRules: "Rimborso 100% fino a 14 giorni, 50% fino a 7 giorni, nessun rimborso dopo.",
    cancelPolicyModerateRules: "Rimborso 100% fino a 21 giorni, 50% fino a 14 giorni, nessun rimborso dopo.",
    cancelPolicyStrictRules: "Rimborso 100% fino a 30 giorni, 50% fino a 21 giorni, nessun rimborso dopo.",
    cancelPolicySaved: "Politica salvata.",
    universalClauses: "Clausole universali: rimborso completo per maltempo e cancellazione da parte dell'operatore.",
    stripeHowTitle: "Come funziona Stripe Connect?",
    stripeHowDesc: "I pagamenti vengono incassati direttamente sul tuo conto Stripe. Nautiqo trattiene una commissione (3%) su ogni transazione riuscita. Stripe applica le proprie commissioni (~1.5%).",
    // notifications tab
    notifPrefs: "Preferenze notifiche",
    notifPrefsDesc: "Scegli come vuoi ricevere gli aggiornamenti sulle prenotazioni.",
    notifEmail: "Notifiche email",
    notifEmailDesc: "Ricevi email per nuove prenotazioni e richieste",
    notifPush: "Notifiche push",
    notifPushDesc: "Ricevi notifiche push sull'app mobile",
    // weather settings tab
    weatherPortsTitle: "Previsioni per i tuoi porti",
    weatherPortsDesc: "Le posizioni vengono prese automaticamente dai porti di partenza delle barche.",
    noPortsSet: "Nessuna barca ha un porto di partenza impostato",
    weatherPreview: "Anteprima previsioni 7 giorni",
    weatherPreviewUnavailable: "Previsioni non disponibili",
    portOK: "Porto OK",
    portMissing: "Senza porto",
    fleetTitle: "Flotta",
    fleetDesc: "Barche che verranno bloccate in caso di maltempo, in base al loro porto.",
    weatherAlertTitle: "Alert Maltempo",
    weatherAlertEnabled: "Attiva notifiche maltempo",
    weatherAlertEnabledDesc: "Ricevi una notifica 3 giorni prima se le condizioni superano le soglie",
    alertThresholds: "Soglie di Allerta",
    alertThresholdsDesc: "L'alert scatta quando almeno una soglia viene superata.",
    waveHeight: "Altezza Onda",
    windSpeed: "Velocità Vento",
    autoActionTitle: "Azione Automatica",
    autoActionDesc: "Cosa succede quando viene rilevato maltempo?",
    askBeforeBlock: "Chiedi prima di bloccare",
    askBeforeBlockDesc: "Ricevi una notifica e decidi tu cosa fare",
    autoBlockLabel: "Blocca automaticamente",
    autoBlockDesc: "Crea subito un blocco per tutte le barche e ti notifica",
    saveWeatherSettings: "Salva Impostazioni Meteo",
    weatherSettingsSaved: "Impostazioni meteo salvate!",
    invalidWaveHeight: "Altezza onda non valida",
    invalidWindSpeed: "Velocità vento non valida",
    noPortsForAlert: "Nessuna barca ha un porto di partenza impostato. Aggiungi il porto alle barche per attivare gli alert.",
    weatherSaveError: "Errore durante il salvataggio",
    weatherLoadError: "Impossibile caricare le previsioni",
    // nuova prenotazione
    newBookingTitle: "Nuova Prenotazione",
    step1Title: "Seleziona data",
    step2Title: "Seleziona barca e orario",
    step3Title: "Seleziona cliente",
    step4Title: "Dettagli prenotazione",
    step5Title: "Riepilogo e conferma",
    timeSlotLabel: "Fascia oraria",
    maxCapacity: "Max",
    existingCustomer: "Cliente esistente",
    newCustomer: "Nuovo cliente",
    searchCustomer: "Cerca per nome, telefono...",
    noCustomerFound: "Nessun cliente trovato",
    noContactInfo: "Nessun contatto",
    experienceType: "Tipo esperienza",
    multiDayRental: "Noleggio multi-giorno",
    startDate: "Data inizio",
    endDate: "Data fine *",
    duration: "Durata:",
    minDaysRequired: "Minimo {n} giorni richiesti",
    numPeople: "Numero persone",
    maxPeople: "Max {n} persone",
    skipperIncluded: "Skipper incluso",
    skipperCost: "Costo skipper:",
    paymentMethodLabel: "Metodo di pagamento",
    bookingSourceLabel: "Provenienza prenotazione",
    customerNotesLabel: "Note del cliente",
    internalNotesLabel: "Note interne",
    depositAmountLabel: "Acconto (€, lascia 0 per nessun acconto)",
    priceLabel: "Prezzo (€)",
    suggestedPrice: "Prezzo suggerito:",
    confirmBooking: "Conferma prenotazione",
    bookingCreating: "Creazione...",
    nameRequired: "Nome e cognome del cliente sono obbligatori",
    customerRequired: "Seleziona o crea un cliente",
    bookingError: "Errore durante la creazione della prenotazione",
    // download redirect
    downloadTitle: "Scarica Nautiqo",
    downloadDesc: "Gestisci prenotazioni, flotta e pagamenti dal tuo smartphone.",
    downloadIOS: "📱 Scarica su App Store (iOS)",
    downloadAndroid: "🤖 Scarica su Google Play (Android)",
    backToSite: "← Torna al sito",
    redirecting: "Reindirizzamento in corso…",
  },

  en: {
    loading: "Loading...",
    unknownError: "Unknown error",
    save: "Save",
    saving: "Saving...",
    cancel: "Cancel",
    delete: "Delete",
    deleting: "Deleting...",
    edit: "Edit",
    confirm: "Confirm",
    back: "Back",
    continua: "Continue",
    open: "Open",
    copy: "Copy",
    copied: "Copied",
    update: "Refresh",
    close: "Close",
    yes: "Yes",
    no: "No",
    fullDay: "Full day",
    morning: "Morning",
    afternoon: "Afternoon",
    sunset: "Sunset",
    statusPending: "Pending",
    statusAccepted: "Accepted",
    statusAwaitingPayment: "Awaiting payment",
    statusConfirmed: "Confirmed",
    statusCompleted: "Completed",
    statusCancelled: "Cancelled",
    statusConfirmedBadge: "Confirmed",
    statusPendingBadge: "Pending",
    statusPaidBadge: "Paid ✓",
    statusConfirmedDeposit: "Confirmed · deposit",
    payUnpaid: "Unpaid",
    payPartialDeposit: "Partial Deposit",
    payDepositReceived: "Deposit Received",
    payFullyPaid: "Fully Paid",
    payRefunded: "Refunded",
    payUnpaidShort: "Unpaid",
    payDepositReceivedShort: "Deposit received",
    payPartialDepositShort: "Partial deposit",
    payPaid: "Paid",
    pmCash: "Cash",
    pmBankTransfer: "Bank transfer",
    pmDebitCard: "Debit card",
    pmCard: "Card",
    pmLink: "Link",
    pmStripe: "Stripe",
    pmPaymentLink: "Payment link",
    pmOther: "Other",
    sourceManual: "Manual",
    sourceWebsite: "Website",
    sourcePhone: "Phone",
    sourceWhatsApp: "WhatsApp",
    sourceAgency: "Agency",
    sourceWeb: "Web",
    sourceApp: "App",
    typeGroup: "Group tour",
    typeExclusive: "Exclusive tour",
    typeRental: "Rental",
    typeGroupShort: "Group",
    typeExclusiveShort: "Exclusive",
    loginSubtitle: "Sign in to your account",
    emailPlaceholder: "email@example.com",
    rememberMe: "Remember me",
    signingIn: "Signing in...",
    signIn: "Sign in",
    noAccount: "Don't have an account?",
    registerFree: "Register for free",
    backToHome: "← Back to home",
    charterMgmt: "Charter Management",
    navCalendar: "Calendar",
    navBookings: "Bookings",
    navBoats: "Boats",
    navRevenue: "Revenue",
    navSettings: "Settings",
    navAccount: "Account",
    userFallback: "User",
    logout: "Log out",
    greetingMorning: "Good morning",
    greetingAfternoon: "Good afternoon",
    greetingEvening: "Good evening",
    charterFallback: "Your Charter",
    expiredTitle: "Limited access",
    expiredMessage: "Your trial has expired. Activate your subscription to restore full access.",
    activateNow: "Activate now",
    paymentIssueTitle: "Payment issue",
    paymentIssueMessage: "Update your payment method to maintain access.",
    manage: "Manage",
    todayLabel: "Today",
    toConfirm: "to confirm",
    unpaidLabel: "unpaid",
    bookingsToday: "Today's bookings",
    confirmedCount: "confirmed",
    fleetToday: "Fleet today",
    available: "available",
    occupied: "occupied",
    pendingRequests: "Pending requests",
    viewAll: "View all →",
    bookingLink: "Booking link",
    todaysBookings: "Today's bookings",
    noBookingsToday: "No bookings today",
    groupTour: "Group tour",
    bookingsSuffix: "bkgs.",
    personsSuffix: "pax",
    multiDayUntil: "Multi-day: until",
    dayLabel: "day",
    daysLabel: "days",
    weatherTitle: "Weather",
    weatherRefresh: "Refresh",
    weatherLoading: "Loading forecast…",
    weatherUnavailable: "Forecast not available",
    weatherTomorrow: "Tomorrow",
    weatherClear: "Clear",
    weatherPartlyCloudy: "Partly cloudy",
    weatherCloudy: "Cloudy",
    weatherFog: "Fog",
    weatherDrizzle: "Drizzle",
    weatherRain: "Rain",
    weatherSnow: "Snow",
    weatherShowers: "Showers",
    weatherSnowWind: "Snow and wind",
    weatherStorm: "Thunderstorm",
    weatherFullWeek: "Full week →",
    weather7Days: "7-day forecast",
    guestFallback: "Guest",
    fieldDate: "Date",
    fieldTimeSlot: "Time slot",
    fieldBoat: "Boat",
    fieldGuests: "People",
    customerNotes: "Customer notes:",
    internalNotes: "Internal notes:",
    fieldTotal: "Total",
    fieldDeposit: "Req. deposit",
    fieldCollected: "Collected",
    fieldRemaining: "Remaining",
    addPayment: "Record payment",
    paymentType: "Type",
    paymentAmount: "Amount €",
    paymentMethod: "Method",
    paymentTypeDeposit: "Deposit",
    paymentTypeBalance: "Balance",
    paymentNotes: "Notes (optional)",
    savePayment: "Save payment",
    paymentHistory: "Payment history",
    editBooking: "Edit booking",
    fieldPriceLabel: "Price €",
    fieldDepositLabel: "Required deposit €",
    internalNotesPlaceholder: "Internal notes",
    saveChanges: "Save changes",
    confirmDelete: "Confirm deletion",
    deleteBooking: "Delete booking",
    noPermission: "You don't have permission for this action",
    saveError: "Error while saving",
    invalidAmount: "Enter a valid amount greater than zero",
    invalidGuests: "Invalid number of guests",
    invalidPrice: "Invalid price",
    invalidDeposit: "Invalid deposit",
    depositExceedsTotal: "The required deposit cannot exceed the total price",
    deletePaymentError: "Error deleting payment",
    searchPlaceholder: "Search customer, boat...",
    filterAll: "All",
    filterUpcoming: "Upcoming",
    filterPast: "Past",
    listView: "List",
    calendarView: "Calendar",
    accept: "Accept",
    reject: "Reject",
    complete: "Completed",
    noContact: "No contact info",
    noBookingsFound: "No bookings found",
    requestsTitle: "Requests",
    noRequestsPending: "No pending requests",
    newRequest: "New request",
    boatsTitle: "Boats",
    addBoat: "Add boat",
    onlyActiveBoats: "Active boats only",
    noBoats: "No boats yet",
    addFirstBoat: "Add your first boat to get started",
    boatActive: "ACTIVE",
    boatInactive: "INACTIVE",
    deactivate: "Deactivate",
    activate: "Activate",
    deleteBoat: "Delete boat",
    deleteBoatConfirm: "Are you sure you want to delete",
    deleteBoatIrreversible: "This action cannot be undone.",
    editBoat: "Edit boat",
    newBoat: "New boat",
    sectionBase: "Basic info",
    sectionModes: "Modes",
    sectionSlots: "Time slots",
    sectionPayment: "Payment",
    sectionSeasonal: "Seasonal",
    boatPhoto: "Boat photo",
    photoUploading: "Uploading...",
    choosePhoto: "Choose photo",
    removePhoto: "Remove",
    boatName: "Boat name *",
    boatNameRequired: "Name is required",
    boatModel: "Model",
    boatCapacity: "Max capacity *",
    boatCapacityRequired: "Enter a valid capacity",
    boatPort: "Departure port *",
    boatPortRequired: "Departure port is required",
    boatWeatherZone: "Weather zone",
    boatWeatherZoneOptional: "(optional)",
    boatWeatherZoneHint: "Only if weather forecasts don't work for the port above",
    boatNotes: "Internal notes",
    boatNotesPlaceholder: "Notes visible only to you...",
    boatShowNotesPublic: "Show notes to customers on the public page",
    boatIsActive: "Boat active",
    boatIsActiveDesc: "If deactivated, it won't appear on the public page",
    modesSelectAtLeast: "Select at least one booking mode",
    modesHint: "Select at least one mode. You can enable multiple on the same boat.",
    tourGroupLabel: "Group Tour",
    tourGroupDesc: "Price per person, multiple guests per trip",
    tourExclusiveLabel: "Exclusive Tour",
    tourExclusiveDesc: "Fixed price for the whole boat",
    tourRentalLabel: "Rental",
    tourRentalDesc: "Bareboat charter",
    pricePerPerson: "Price per person (€)",
    priceHalfDay: "Half day (€)",
    priceFullDay: "Full day (€)",
    priceSunset: "Sunset (€)",
    skipperAvailable: "Skipper available",
    skipperMode: "Skipper mode",
    skipperOnRequest: "On request",
    skipperAlwaysIncluded: "Always included",
    skipperPrice: "Skipper daily price (€)",
    multiDayEnabled: "Enable multi-day rental",
    multiDayMin: "Minimum duration (days)",
    multiDayMax: "Maximum duration (days, empty = unlimited)",
    bookingMode: "Booking mode",
    bookingModeRequest: "On request (you confirm)",
    bookingModeInstant: "Instant (auto-confirmed)",
    paymentFull: "Full payment",
    paymentDeposit: "Deposit only",
    depositPercent: "Deposit %",
    seasonalPricing: "Seasonal pricing",
    addSeasonalRule: "Add rule",
    seasonalRuleName: "Season name",
    seasonalFrom: "From",
    seasonalTo: "To",
    seasonalSave: "Save rule",
    revenueTitle: "Revenue",
    exportCSV: "Export CSV",
    periodDay: "Day",
    periodWeek: "Week",
    periodMonth: "Month",
    periodYear: "Year",
    typeGroupTourLabel: "Group tours",
    typeExclusiveTourLabel: "Exclusives",
    typeRentalLabel: "Rentals",
    typeOtherLabel: "Other",
    boatUnknown: "Unknown",
    csvDate: "Date",
    csvBoat: "Boat",
    csvCustomer: "Customer",
    csvType: "Type",
    csvTotal: "Total",
    csvDeposit: "Deposit",
    csvBalance: "Balance",
    csvPaymentStatus: "Payment status",
    revenueByType: "Summary by Type",
    revenueByBoat: "Revenue by Vessel",
    revenueBookings: "bookings",
    revenueCollected: "Collected",
    revenueTotal: "Total",
    revenueOfTotal: "of total",
    revenueGuests: "guests",
    revenueDeposits: "Deposits",
    revenueRemaining: "Outstanding",
    csvExportError: "Export failed",
    settingsTitle: "Settings",
    settingsSubtitle: "Profile, payments, online bookings and notifications.",
    tabProfile: "Profile",
    tabBookings: "Bookings",
    tabPayments: "Payments",
    tabNotifications: "Notifications",
    tabWeather: "⛈ Weather",
    profileUpdated: "Profile updated successfully.",
    saveError2: "Error saving.",
    logoUploadError: "Error uploading logo.",
    logoUploading: "Uploading",
    changeLogo: "Change logo",
    subscriptionActive: "Active subscription",
    subscriptionTrial: "Trial active",
    subscriptionExpired: "Subscription expired",
    personalData: "Personal data",
    fieldFirstName: "First name",
    fieldLastName: "Last name",
    fieldEmail: "Email",
    fieldPhone: "Phone",
    companyData: "Company data",
    companyName: "Business name",
    vatNumber: "VAT number",
    sdiCode: "SDI code",
    pec: "PEC email",
    address: "Address",
    city: "City",
    zip: "ZIP code",
    website: "Website",
    changePassword: "Change password",
    newPassword: "New password",
    newPasswordPlaceholder: "At least 8 characters",
    confirmPassword: "Confirm password",
    confirmPasswordPlaceholder: "Repeat new password",
    passwordMinLength: "New password must be at least 8 characters.",
    passwordMismatch: "Passwords do not match.",
    passwordUpdated: "Password updated.",
    passwordError: "Error changing password.",
    updatingPassword: "Updating...",
    updatePassword: "Update password",
    publicBookingLink: "Public booking link",
    publicBookingLinkDesc: "Share this link with your customers. They can see your boats and book directly, 24/7.",
    featureNotAvailable: "Feature not available on your plan",
    upgradeToEnable: "Upgrade your subscription to enable online bookings.",
    howToIntegrate: "How to integrate on your website",
    integrationStep1: "Copy the link above",
    integrationStep2: "Add it as a 'Book now' button on your website",
    integrationStep3: "Customers land on the Nautiqo page, choose a boat and book",
    integrationStep4: "You receive the notification and manage everything from the dashboard",
    siteWebLabel: "Website",
    siteWebDesc: "Add the link as a CTA",
    instagramLabel: "Instagram",
    instagramDesc: "Link in bio or stories",
    whatsappLabel: "WhatsApp",
    whatsappDesc: "Send to direct customers",
    copiedBang: "Copied!",
    stripeNotConfigured: "Not configured",
    stripeVerifying: "Under review — complete the setup",
    stripeActive: "Active · payments enabled",
    stripeComplete: "Complete",
    stripeConnect: "Connect",
    stripeWaiting: "Please wait",
    stripeCharges: "Charges",
    stripePayouts: "Payouts",
    stripeCommission: "Commission",
    stripeEnabled: "✓ Enabled",
    stripePending: "Pending",
    absorbFees: "Absorb +5% fee",
    absorbFeesDesc: "Customer pays 5% more; you receive the net amount",
    absorbFeesActive: "+5% fee activated. Customers will see the marked-up price.",
    absorbFeesInactive: "+5% fee deactivated.",
    cancelPolicy: "Cancellation policy",
    cancelPolicyDesc: "Applies to bookings paid with an online deposit.",
    cancelPolicyFlexible: "Flexible",
    cancelPolicyModerate: "Moderate",
    cancelPolicyStrict: "Strict",
    cancelPolicyFlexibleRules: "100% refund up to 14 days, 50% up to 7 days, no refund after.",
    cancelPolicyModerateRules: "100% refund up to 21 days, 50% up to 14 days, no refund after.",
    cancelPolicyStrictRules: "100% refund up to 30 days, 50% up to 21 days, no refund after.",
    cancelPolicySaved: "Policy saved.",
    universalClauses: "Universal clauses: full refund for bad weather and operator cancellation.",
    stripeHowTitle: "How does Stripe Connect work?",
    stripeHowDesc: "Payments are collected directly into your Stripe account. Nautiqo retains a commission (3%) on each successful transaction. Stripe applies its own fees (~1.5%).",
    notifPrefs: "Notification preferences",
    notifPrefsDesc: "Choose how you want to receive booking updates.",
    notifEmail: "Email notifications",
    notifEmailDesc: "Receive emails for new bookings and requests",
    notifPush: "Push notifications",
    notifPushDesc: "Receive push notifications on the mobile app",
    weatherPortsTitle: "Forecasts for your ports",
    weatherPortsDesc: "Locations are automatically taken from boat departure ports.",
    noPortsSet: "No boat has a departure port set",
    weatherPreview: "7-day forecast preview",
    weatherPreviewUnavailable: "Forecast not available",
    portOK: "Port OK",
    portMissing: "No port",
    fleetTitle: "Fleet",
    fleetDesc: "Boats that will be blocked in case of bad weather, based on their port.",
    weatherAlertTitle: "Bad Weather Alert",
    weatherAlertEnabled: "Enable weather alerts",
    weatherAlertEnabledDesc: "Receive a notification 3 days before if conditions exceed thresholds",
    alertThresholds: "Alert Thresholds",
    alertThresholdsDesc: "Alert triggers when at least one threshold is exceeded.",
    waveHeight: "Wave Height",
    windSpeed: "Wind Speed",
    autoActionTitle: "Automatic Action",
    autoActionDesc: "What happens when bad weather is detected?",
    askBeforeBlock: "Ask before blocking",
    askBeforeBlockDesc: "Receive a notification and decide what to do",
    autoBlockLabel: "Block automatically",
    autoBlockDesc: "Immediately create a block for all boats and notify you",
    saveWeatherSettings: "Save Weather Settings",
    weatherSettingsSaved: "Weather settings saved!",
    invalidWaveHeight: "Invalid wave height",
    invalidWindSpeed: "Invalid wind speed",
    noPortsForAlert: "No boat has a departure port set. Add the port to boats to enable alerts.",
    weatherSaveError: "Error while saving",
    weatherLoadError: "Unable to load forecast",
    newBookingTitle: "New Booking",
    step1Title: "Select date",
    step2Title: "Select boat and time",
    step3Title: "Select customer",
    step4Title: "Booking details",
    step5Title: "Summary & confirm",
    timeSlotLabel: "Time slot",
    maxCapacity: "Max",
    existingCustomer: "Existing customer",
    newCustomer: "New customer",
    searchCustomer: "Search by name, phone...",
    noCustomerFound: "No customers found",
    noContactInfo: "No contact info",
    experienceType: "Experience type",
    multiDayRental: "Multi-day rental",
    startDate: "Start date",
    endDate: "End date *",
    duration: "Duration:",
    minDaysRequired: "Minimum {n} days required",
    numPeople: "Number of people",
    maxPeople: "Max {n} people",
    skipperIncluded: "Skipper included",
    skipperCost: "Skipper cost:",
    paymentMethodLabel: "Payment method",
    bookingSourceLabel: "Booking source",
    customerNotesLabel: "Customer notes",
    internalNotesLabel: "Internal notes",
    depositAmountLabel: "Deposit (€, leave 0 for no deposit)",
    priceLabel: "Price (€)",
    suggestedPrice: "Suggested price:",
    confirmBooking: "Confirm booking",
    bookingCreating: "Creating...",
    nameRequired: "Customer first and last name are required",
    customerRequired: "Select or create a customer",
    bookingError: "Error creating booking",
    downloadTitle: "Download Nautiqo",
    downloadDesc: "Manage bookings, fleet and payments from your smartphone.",
    downloadIOS: "📱 Download on App Store (iOS)",
    downloadAndroid: "🤖 Download on Google Play (Android)",
    backToSite: "← Back to site",
    redirecting: "Redirecting…",
  },

  es: {
    loading: "Cargando...",
    unknownError: "Error desconocido",
    save: "Guardar",
    saving: "Guardando...",
    cancel: "Cancelar",
    delete: "Eliminar",
    deleting: "Eliminando...",
    edit: "Editar",
    confirm: "Confirmar",
    back: "Atrás",
    continua: "Continuar",
    open: "Abrir",
    copy: "Copiar",
    copied: "Copiado",
    update: "Actualizar",
    close: "Cerrar",
    yes: "Sí",
    no: "No",
    fullDay: "Día completo",
    morning: "Mañana",
    afternoon: "Tarde",
    sunset: "Atardecer",
    statusPending: "Pendiente",
    statusAccepted: "Aceptado",
    statusAwaitingPayment: "Esperando pago",
    statusConfirmed: "Confirmado",
    statusCompleted: "Completado",
    statusCancelled: "Cancelado",
    statusConfirmedBadge: "Confirmada",
    statusPendingBadge: "Pendiente",
    statusPaidBadge: "Pagado ✓",
    statusConfirmedDeposit: "Confirmado · depósito",
    payUnpaid: "No pagado",
    payPartialDeposit: "Depósito parcial",
    payDepositReceived: "Depósito recibido",
    payFullyPaid: "Pagado",
    payRefunded: "Reembolsado",
    payUnpaidShort: "No pagado",
    payDepositReceivedShort: "Depósito recibido",
    payPartialDepositShort: "Depósito parcial",
    payPaid: "Pagado",
    pmCash: "Efectivo",
    pmBankTransfer: "Transferencia",
    pmDebitCard: "Tarjeta débito",
    pmCard: "Tarjeta",
    pmLink: "Enlace",
    pmStripe: "Stripe",
    pmPaymentLink: "Enlace de pago",
    pmOther: "Otro",
    sourceManual: "Manual",
    sourceWebsite: "Sitio web",
    sourcePhone: "Teléfono",
    sourceWhatsApp: "WhatsApp",
    sourceAgency: "Agencia",
    sourceWeb: "Web",
    sourceApp: "App",
    typeGroup: "Tour en grupo",
    typeExclusive: "Tour exclusivo",
    typeRental: "Alquiler",
    typeGroupShort: "Grupo",
    typeExclusiveShort: "Exclusivo",
    loginSubtitle: "Accede a tu cuenta",
    emailPlaceholder: "email@ejemplo.com",
    rememberMe: "Recuérdame",
    signingIn: "Accediendo...",
    signIn: "Acceder",
    noAccount: "¿No tienes cuenta?",
    registerFree: "Regístrate gratis",
    backToHome: "← Volver al inicio",
    charterMgmt: "Gestión Charter",
    navCalendar: "Calendario",
    navBookings: "Reservas",
    navBoats: "Embarcaciones",
    navRevenue: "Facturación",
    navSettings: "Ajustes",
    navAccount: "Cuenta",
    userFallback: "Usuario",
    logout: "Cerrar sesión",
    greetingMorning: "Buenos días",
    greetingAfternoon: "Buenas tardes",
    greetingEvening: "Buenas noches",
    charterFallback: "Tu Charter",
    expiredTitle: "Acceso limitado",
    expiredMessage: "Tu período de prueba ha expirado. Activa la suscripción para recuperar el acceso completo.",
    activateNow: "Activar ahora",
    paymentIssueTitle: "Problema de pago",
    paymentIssueMessage: "Actualiza el método de pago para mantener el acceso.",
    manage: "Gestionar",
    todayLabel: "Hoy",
    toConfirm: "por confirmar",
    unpaidLabel: "no pagadas",
    bookingsToday: "Reservas hoy",
    confirmedCount: "confirmadas",
    fleetToday: "Flota hoy",
    available: "disponibles",
    occupied: "ocupadas",
    pendingRequests: "Solicitudes pendientes",
    viewAll: "Ver todas →",
    bookingLink: "Enlace de reserva",
    todaysBookings: "Reservas de hoy",
    noBookingsToday: "Sin reservas hoy",
    groupTour: "Tour en grupo",
    bookingsSuffix: "res.",
    personsSuffix: "pers.",
    multiDayUntil: "Multidía: hasta el",
    dayLabel: "día",
    daysLabel: "días",
    weatherTitle: "Tiempo",
    weatherRefresh: "Actualizar",
    weatherLoading: "Cargando previsión…",
    weatherUnavailable: "Previsión no disponible",
    weatherTomorrow: "Mañana",
    weatherClear: "Despejado",
    weatherPartlyCloudy: "Parcialmente nublado",
    weatherCloudy: "Nublado",
    weatherFog: "Niebla",
    weatherDrizzle: "Llovizna",
    weatherRain: "Lluvia",
    weatherSnow: "Nieve",
    weatherShowers: "Chubascos",
    weatherSnowWind: "Nieve y viento",
    weatherStorm: "Tormenta",
    weatherFullWeek: "Semana completa →",
    weather7Days: "Previsión 7 días",
    guestFallback: "Cliente",
    fieldDate: "Fecha",
    fieldTimeSlot: "Franja horaria",
    fieldBoat: "Embarcación",
    fieldGuests: "Personas",
    customerNotes: "Notas cliente:",
    internalNotes: "Notas internas:",
    fieldTotal: "Total",
    fieldDeposit: "Depósito req.",
    fieldCollected: "Cobrado",
    fieldRemaining: "Pendiente",
    addPayment: "Registrar pago",
    paymentType: "Tipo",
    paymentAmount: "Importe €",
    paymentMethod: "Método",
    paymentTypeDeposit: "Depósito",
    paymentTypeBalance: "Saldo",
    paymentNotes: "Notas (opcional)",
    savePayment: "Guardar pago",
    paymentHistory: "Historial de pagos",
    editBooking: "Editar reserva",
    fieldPriceLabel: "Precio €",
    fieldDepositLabel: "Depósito requerido €",
    internalNotesPlaceholder: "Notas internas",
    saveChanges: "Guardar cambios",
    confirmDelete: "Confirmar eliminación",
    deleteBooking: "Eliminar reserva",
    noPermission: "No tienes permisos para esta acción",
    saveError: "Error al guardar",
    invalidAmount: "Introduce un importe válido mayor que cero",
    invalidGuests: "Número de personas no válido",
    invalidPrice: "Precio no válido",
    invalidDeposit: "Depósito no válido",
    depositExceedsTotal: "El depósito requerido no puede superar el precio total",
    deletePaymentError: "Error al eliminar el pago",
    searchPlaceholder: "Buscar cliente, embarcación...",
    filterAll: "Todas",
    filterUpcoming: "Próximas",
    filterPast: "Pasadas",
    listView: "Lista",
    calendarView: "Calendario",
    accept: "Aceptar",
    reject: "Rechazar",
    complete: "Completada",
    noContact: "Sin datos de contacto",
    noBookingsFound: "Sin reservas encontradas",
    requestsTitle: "Solicitudes",
    noRequestsPending: "Sin solicitudes pendientes",
    newRequest: "Nueva solicitud",
    boatsTitle: "Embarcaciones",
    addBoat: "Añadir embarcación",
    onlyActiveBoats: "Solo embarcaciones activas",
    noBoats: "Sin embarcaciones todavía",
    addFirstBoat: "Añade tu primera embarcación para empezar",
    boatActive: "ACTIVA",
    boatInactive: "INACTIVA",
    deactivate: "Desactivar",
    activate: "Activar",
    deleteBoat: "Eliminar embarcación",
    deleteBoatConfirm: "¿Seguro que quieres eliminar",
    deleteBoatIrreversible: "Esta acción no se puede deshacer.",
    editBoat: "Editar embarcación",
    newBoat: "Nueva embarcación",
    sectionBase: "Info básica",
    sectionModes: "Modalidades",
    sectionSlots: "Franjas horarias",
    sectionPayment: "Pago",
    sectionSeasonal: "Estacional",
    boatPhoto: "Foto embarcación",
    photoUploading: "Subiendo...",
    choosePhoto: "Elegir foto",
    removePhoto: "Eliminar",
    boatName: "Nombre embarcación *",
    boatNameRequired: "El nombre es obligatorio",
    boatModel: "Modelo",
    boatCapacity: "Capacidad máxima *",
    boatCapacityRequired: "Introduce una capacidad válida",
    boatPort: "Puerto de salida *",
    boatPortRequired: "El puerto de salida es obligatorio",
    boatWeatherZone: "Zona meteorológica",
    boatWeatherZoneOptional: "(opcional)",
    boatWeatherZoneHint: "Solo si las previsiones no funcionan para el puerto indicado",
    boatNotes: "Notas internas",
    boatNotesPlaceholder: "Notas visibles solo para ti...",
    boatShowNotesPublic: "Mostrar notas a clientes en la página pública",
    boatIsActive: "Embarcación activa",
    boatIsActiveDesc: "Si se desactiva no aparecerá en la página pública",
    modesSelectAtLeast: "Selecciona al menos una modalidad de reserva",
    modesHint: "Selecciona al menos una modalidad. Puedes habilitar varias en la misma embarcación.",
    tourGroupLabel: "Tour en Grupo",
    tourGroupDesc: "Precio por persona, varios clientes por excursión",
    tourExclusiveLabel: "Tour Exclusivo",
    tourExclusiveDesc: "Precio fijo para toda la embarcación",
    tourRentalLabel: "Alquiler",
    tourRentalDesc: "Chárter sin tripulación",
    pricePerPerson: "Precio por persona (€)",
    priceHalfDay: "Medio día (€)",
    priceFullDay: "Día completo (€)",
    priceSunset: "Atardecer (€)",
    skipperAvailable: "Patrón disponible",
    skipperMode: "Modalidad patrón",
    skipperOnRequest: "Bajo petición",
    skipperAlwaysIncluded: "Siempre incluido",
    skipperPrice: "Precio diario patrón (€)",
    multiDayEnabled: "Habilitar alquiler multiday",
    multiDayMin: "Duración mínima (días)",
    multiDayMax: "Duración máxima (días, vacío = ilimitado)",
    bookingMode: "Modo de reserva",
    bookingModeRequest: "Bajo petición (tú confirmas)",
    bookingModeInstant: "Inmediata (auto-confirmada)",
    paymentFull: "Pago completo",
    paymentDeposit: "Solo depósito",
    depositPercent: "% depósito requerido",
    seasonalPricing: "Precios estacionales",
    addSeasonalRule: "Añadir regla",
    seasonalRuleName: "Nombre de temporada",
    seasonalFrom: "Desde",
    seasonalTo: "Hasta",
    seasonalSave: "Guardar regla",
    revenueTitle: "Facturación",
    exportCSV: "Exportar CSV",
    periodDay: "Día",
    periodWeek: "Semana",
    periodMonth: "Mes",
    periodYear: "Año",
    typeGroupTourLabel: "Tours en grupo",
    typeExclusiveTourLabel: "Exclusivos",
    typeRentalLabel: "Alquileres",
    typeOtherLabel: "Otro",
    boatUnknown: "Desconocida",
    csvDate: "Fecha",
    csvBoat: "Embarcación",
    csvCustomer: "Cliente",
    csvType: "Tipo",
    csvTotal: "Total",
    csvDeposit: "Depósito",
    csvBalance: "Saldo",
    csvPaymentStatus: "Estado de pago",
    revenueByType: "Resumen por tipología",
    revenueByBoat: "Facturación por embarcación",
    revenueBookings: "reservas",
    revenueCollected: "Cobrado",
    revenueTotal: "Total",
    revenueOfTotal: "del total",
    revenueGuests: "pasajeros",
    revenueDeposits: "Anticipos",
    revenueRemaining: "Pendiente",
    csvExportError: "Error al exportar",
    settingsTitle: "Ajustes",
    settingsSubtitle: "Perfil, pagos, reservas online y notificaciones.",
    tabProfile: "Perfil",
    tabBookings: "Reservas",
    tabPayments: "Pagos",
    tabNotifications: "Notificaciones",
    tabWeather: "⛈ Tiempo",
    profileUpdated: "Perfil actualizado correctamente.",
    saveError2: "Error al guardar.",
    logoUploadError: "Error al subir el logotipo.",
    logoUploading: "Subiendo",
    changeLogo: "Cambiar logo",
    subscriptionActive: "Suscripción activa",
    subscriptionTrial: "Prueba activa",
    subscriptionExpired: "Suscripción expirada",
    personalData: "Datos personales",
    fieldFirstName: "Nombre",
    fieldLastName: "Apellido",
    fieldEmail: "Email",
    fieldPhone: "Teléfono",
    companyData: "Datos de empresa",
    companyName: "Nombre del negocio",
    vatNumber: "NIF/CIF",
    sdiCode: "Código SDI",
    pec: "Email PEC",
    address: "Dirección",
    city: "Ciudad",
    zip: "Código postal",
    website: "Sitio web",
    changePassword: "Cambiar contraseña",
    newPassword: "Nueva contraseña",
    newPasswordPlaceholder: "Mínimo 8 caracteres",
    confirmPassword: "Confirmar contraseña",
    confirmPasswordPlaceholder: "Repite la nueva contraseña",
    passwordMinLength: "La nueva contraseña debe tener al menos 8 caracteres.",
    passwordMismatch: "Las contraseñas no coinciden.",
    passwordUpdated: "Contraseña actualizada.",
    passwordError: "Error al cambiar la contraseña.",
    updatingPassword: "Actualizando...",
    updatePassword: "Actualizar contraseña",
    publicBookingLink: "Enlace de reserva pública",
    publicBookingLinkDesc: "Comparte este enlace con tus clientes. Pueden ver tus embarcaciones y reservar directamente, 24/7.",
    featureNotAvailable: "Función no disponible en tu plan",
    upgradeToEnable: "Actualiza la suscripción para habilitar las reservas online.",
    howToIntegrate: "Cómo integrar en tu sitio web",
    integrationStep1: "Copia el enlace de arriba",
    integrationStep2: "Añádelo como botón \"Reservar ahora\" en tu sitio web",
    integrationStep3: "Los clientes llegan a la página Nautiqo, eligen la embarcación y reservan",
    integrationStep4: "Recibes la notificación y gestionas todo desde el panel",
    siteWebLabel: "Sitio web",
    siteWebDesc: "Añade el enlace como CTA",
    instagramLabel: "Instagram",
    instagramDesc: "Enlace en bio o stories",
    whatsappLabel: "WhatsApp",
    whatsappDesc: "Envía a clientes directos",
    copiedBang: "¡Copiado!",
    stripeNotConfigured: "No configurado",
    stripeVerifying: "En verificación — completa la configuración",
    stripeActive: "Activo · pagos habilitados",
    stripeComplete: "Completar",
    stripeConnect: "Conectar",
    stripeWaiting: "Por favor espera",
    stripeCharges: "Cobros",
    stripePayouts: "Pagos",
    stripeCommission: "Comisión",
    stripeEnabled: "✓ Habilitados",
    stripePending: "Pendiente",
    absorbFees: "Absorber comisión +5%",
    absorbFeesDesc: "El cliente paga un 5% más; tú recibes el neto",
    absorbFeesActive: "Comisión +5% activada. Los clientes verán el precio aumentado.",
    absorbFeesInactive: "Comisión +5% desactivada.",
    cancelPolicy: "Política de cancelación",
    cancelPolicyDesc: "Se aplica a reservas pagadas con depósito online.",
    cancelPolicyFlexible: "Flexible",
    cancelPolicyModerate: "Moderada",
    cancelPolicyStrict: "Estricta",
    cancelPolicyFlexibleRules: "Reembolso 100% hasta 14 días, 50% hasta 7 días, sin reembolso después.",
    cancelPolicyModerateRules: "Reembolso 100% hasta 21 días, 50% hasta 14 días, sin reembolso después.",
    cancelPolicyStrictRules: "Reembolso 100% hasta 30 días, 50% hasta 21 días, sin reembolso después.",
    cancelPolicySaved: "Política guardada.",
    universalClauses: "Cláusulas universales: reembolso completo por mal tiempo y cancelación por parte del operador.",
    stripeHowTitle: "¿Cómo funciona Stripe Connect?",
    stripeHowDesc: "Los pagos se cobran directamente en tu cuenta Stripe. Nautiqo retiene una comisión (3%) en cada transacción exitosa. Stripe aplica sus propias comisiones (~1.5%).",
    notifPrefs: "Preferencias de notificaciones",
    notifPrefsDesc: "Elige cómo quieres recibir las actualizaciones de reservas.",
    notifEmail: "Notificaciones por email",
    notifEmailDesc: "Recibe emails para nuevas reservas y solicitudes",
    notifPush: "Notificaciones push",
    notifPushDesc: "Recibe notificaciones push en la app móvil",
    weatherPortsTitle: "Previsiones para tus puertos",
    weatherPortsDesc: "Las ubicaciones se toman automáticamente de los puertos de salida de las embarcaciones.",
    noPortsSet: "Ninguna embarcación tiene puerto de salida configurado",
    weatherPreview: "Vista previa previsión 7 días",
    weatherPreviewUnavailable: "Previsión no disponible",
    portOK: "Puerto OK",
    portMissing: "Sin puerto",
    fleetTitle: "Flota",
    fleetDesc: "Embarcaciones que se bloquearán en caso de mal tiempo, según su puerto.",
    weatherAlertTitle: "Alerta Meteorológica",
    weatherAlertEnabled: "Activar alertas de mal tiempo",
    weatherAlertEnabledDesc: "Recibe una notificación 3 días antes si las condiciones superan los umbrales",
    alertThresholds: "Umbrales de Alerta",
    alertThresholdsDesc: "La alerta se activa cuando al menos un umbral es superado.",
    waveHeight: "Altura de ola",
    windSpeed: "Velocidad del viento",
    autoActionTitle: "Acción Automática",
    autoActionDesc: "¿Qué ocurre cuando se detecta mal tiempo?",
    askBeforeBlock: "Preguntar antes de bloquear",
    askBeforeBlockDesc: "Recibe una notificación y decide tú qué hacer",
    autoBlockLabel: "Bloquear automáticamente",
    autoBlockDesc: "Crea inmediatamente un bloqueo para todas las embarcaciones y te notifica",
    saveWeatherSettings: "Guardar Configuración Meteorológica",
    weatherSettingsSaved: "¡Configuración meteorológica guardada!",
    invalidWaveHeight: "Altura de ola no válida",
    invalidWindSpeed: "Velocidad de viento no válida",
    noPortsForAlert: "Ninguna embarcación tiene puerto de salida. Añade el puerto a las embarcaciones para activar las alertas.",
    weatherSaveError: "Error al guardar",
    weatherLoadError: "No se puede cargar la previsión",
    newBookingTitle: "Nueva Reserva",
    step1Title: "Seleccionar fecha",
    step2Title: "Seleccionar embarcación y horario",
    step3Title: "Seleccionar cliente",
    step4Title: "Detalles de la reserva",
    step5Title: "Resumen y confirmar",
    timeSlotLabel: "Franja horaria",
    maxCapacity: "Máx.",
    existingCustomer: "Cliente existente",
    newCustomer: "Nuevo cliente",
    searchCustomer: "Buscar por nombre, teléfono...",
    noCustomerFound: "No se encontraron clientes",
    noContactInfo: "Sin datos de contacto",
    experienceType: "Tipo de experiencia",
    multiDayRental: "Alquiler multiday",
    startDate: "Fecha inicio",
    endDate: "Fecha fin *",
    duration: "Duración:",
    minDaysRequired: "Mínimo {n} días requeridos",
    numPeople: "Número de personas",
    maxPeople: "Máx. {n} personas",
    skipperIncluded: "Patrón incluido",
    skipperCost: "Coste patrón:",
    paymentMethodLabel: "Método de pago",
    bookingSourceLabel: "Origen de la reserva",
    customerNotesLabel: "Notas del cliente",
    internalNotesLabel: "Notas internas",
    depositAmountLabel: "Depósito (€, deja 0 para sin depósito)",
    priceLabel: "Precio (€)",
    suggestedPrice: "Precio sugerido:",
    confirmBooking: "Confirmar reserva",
    bookingCreating: "Creando...",
    nameRequired: "El nombre y apellido del cliente son obligatorios",
    customerRequired: "Selecciona o crea un cliente",
    bookingError: "Error al crear la reserva",
    downloadTitle: "Descarga Nautiqo",
    downloadDesc: "Gestiona reservas, flota y pagos desde tu smartphone.",
    downloadIOS: "📱 Descargar en App Store (iOS)",
    downloadAndroid: "🤖 Descargar en Google Play (Android)",
    backToSite: "← Volver al sitio",
    redirecting: "Redirigiendo…",
  },

  fr: {
    loading: "Chargement...",
    unknownError: "Erreur inconnue",
    save: "Enregistrer",
    saving: "Enregistrement...",
    cancel: "Annuler",
    delete: "Supprimer",
    deleting: "Suppression...",
    edit: "Modifier",
    confirm: "Confirmer",
    back: "Retour",
    continua: "Continuer",
    open: "Ouvrir",
    copy: "Copier",
    copied: "Copié",
    update: "Actualiser",
    close: "Fermer",
    yes: "Oui",
    no: "Non",
    fullDay: "Journée complète",
    morning: "Matin",
    afternoon: "Après-midi",
    sunset: "Coucher de soleil",
    statusPending: "En attente",
    statusAccepted: "Accepté",
    statusAwaitingPayment: "Att. paiement",
    statusConfirmed: "Confirmé",
    statusCompleted: "Terminé",
    statusCancelled: "Annulé",
    statusConfirmedBadge: "Confirmée",
    statusPendingBadge: "En attente",
    statusPaidBadge: "Payé ✓",
    statusConfirmedDeposit: "Confirmé · acompte",
    payUnpaid: "Non payé",
    payPartialDeposit: "Acompte partiel",
    payDepositReceived: "Acompte reçu",
    payFullyPaid: "Entièrement payé",
    payRefunded: "Remboursé",
    payUnpaidShort: "Non payé",
    payDepositReceivedShort: "Acompte reçu",
    payPartialDepositShort: "Acompte partiel",
    payPaid: "Payé",
    pmCash: "Espèces",
    pmBankTransfer: "Virement",
    pmDebitCard: "Carte bancaire",
    pmCard: "Carte",
    pmLink: "Lien",
    pmStripe: "Stripe",
    pmPaymentLink: "Lien de paiement",
    pmOther: "Autre",
    sourceManual: "Manuel",
    sourceWebsite: "Site web",
    sourcePhone: "Téléphone",
    sourceWhatsApp: "WhatsApp",
    sourceAgency: "Agence",
    sourceWeb: "Web",
    sourceApp: "App",
    typeGroup: "Tour en groupe",
    typeExclusive: "Tour exclusif",
    typeRental: "Location",
    typeGroupShort: "Groupe",
    typeExclusiveShort: "Exclusif",
    loginSubtitle: "Connectez-vous à votre compte",
    emailPlaceholder: "email@exemple.com",
    rememberMe: "Se souvenir de moi",
    signingIn: "Connexion...",
    signIn: "Se connecter",
    noAccount: "Pas encore de compte ?",
    registerFree: "S'inscrire gratuitement",
    backToHome: "← Retour à l'accueil",
    charterMgmt: "Gestion Charter",
    navCalendar: "Calendrier",
    navBookings: "Réservations",
    navBoats: "Bateaux",
    navRevenue: "Chiffre d'affaires",
    navSettings: "Paramètres",
    navAccount: "Compte",
    userFallback: "Utilisateur",
    logout: "Se déconnecter",
    greetingMorning: "Bonjour",
    greetingAfternoon: "Bon après-midi",
    greetingEvening: "Bonsoir",
    charterFallback: "Votre Charter",
    expiredTitle: "Accès limité",
    expiredMessage: "Votre période d'essai a expiré. Activez votre abonnement pour retrouver l'accès complet.",
    activateNow: "Activer maintenant",
    paymentIssueTitle: "Problème de paiement",
    paymentIssueMessage: "Mettez à jour votre moyen de paiement pour conserver l'accès.",
    manage: "Gérer",
    todayLabel: "Aujourd'hui",
    toConfirm: "à confirmer",
    unpaidLabel: "non payées",
    bookingsToday: "Réservations aujourd'hui",
    confirmedCount: "confirmées",
    fleetToday: "Flotte aujourd'hui",
    available: "disponibles",
    occupied: "occupés",
    pendingRequests: "Demandes en attente",
    viewAll: "Voir tout →",
    bookingLink: "Lien de réservation",
    todaysBookings: "Réservations du jour",
    noBookingsToday: "Aucune réservation aujourd'hui",
    groupTour: "Tour en groupe",
    bookingsSuffix: "rés.",
    personsSuffix: "pers.",
    multiDayUntil: "Multi-jours : jusqu'au",
    dayLabel: "jour",
    daysLabel: "jours",
    weatherTitle: "Météo",
    weatherRefresh: "Actualiser",
    weatherLoading: "Chargement des prévisions…",
    weatherUnavailable: "Prévisions indisponibles",
    weatherTomorrow: "Demain",
    weatherClear: "Clair",
    weatherPartlyCloudy: "Partiellement nuageux",
    weatherCloudy: "Nuageux",
    weatherFog: "Brouillard",
    weatherDrizzle: "Bruine",
    weatherRain: "Pluie",
    weatherSnow: "Neige",
    weatherShowers: "Averses",
    weatherSnowWind: "Neige et vent",
    weatherStorm: "Orage",
    weatherFullWeek: "Semaine complète →",
    weather7Days: "Prévisions 7 jours",
    guestFallback: "Client",
    fieldDate: "Date",
    fieldTimeSlot: "Créneau horaire",
    fieldBoat: "Bateau",
    fieldGuests: "Personnes",
    customerNotes: "Notes client :",
    internalNotes: "Notes internes :",
    fieldTotal: "Total",
    fieldDeposit: "Acompte req.",
    fieldCollected: "Encaissé",
    fieldRemaining: "Restant",
    addPayment: "Enregistrer paiement",
    paymentType: "Type",
    paymentAmount: "Montant €",
    paymentMethod: "Méthode",
    paymentTypeDeposit: "Acompte",
    paymentTypeBalance: "Solde",
    paymentNotes: "Notes (facultatif)",
    savePayment: "Enregistrer le paiement",
    paymentHistory: "Historique des paiements",
    editBooking: "Modifier la réservation",
    fieldPriceLabel: "Prix €",
    fieldDepositLabel: "Acompte requis €",
    internalNotesPlaceholder: "Notes internes",
    saveChanges: "Enregistrer les modifications",
    confirmDelete: "Confirmer la suppression",
    deleteBooking: "Supprimer la réservation",
    noPermission: "Vous n'avez pas les permissions pour cette action",
    saveError: "Erreur lors de l'enregistrement",
    invalidAmount: "Entrez un montant valide supérieur à zéro",
    invalidGuests: "Nombre de personnes invalide",
    invalidPrice: "Prix invalide",
    invalidDeposit: "Acompte invalide",
    depositExceedsTotal: "L'acompte requis ne peut pas dépasser le prix total",
    deletePaymentError: "Erreur lors de la suppression du paiement",
    searchPlaceholder: "Rechercher client, bateau...",
    filterAll: "Toutes",
    filterUpcoming: "À venir",
    filterPast: "Passées",
    listView: "Liste",
    calendarView: "Calendrier",
    accept: "Accepter",
    reject: "Refuser",
    complete: "Terminée",
    noContact: "Aucun contact",
    noBookingsFound: "Aucune réservation trouvée",
    requestsTitle: "Demandes",
    noRequestsPending: "Aucune demande en attente",
    newRequest: "Nouvelle demande",
    boatsTitle: "Bateaux",
    addBoat: "Ajouter un bateau",
    onlyActiveBoats: "Bateaux actifs uniquement",
    noBoats: "Aucun bateau pour l'instant",
    addFirstBoat: "Ajoutez votre premier bateau pour commencer",
    boatActive: "ACTIF",
    boatInactive: "INACTIF",
    deactivate: "Désactiver",
    activate: "Activer",
    deleteBoat: "Supprimer le bateau",
    deleteBoatConfirm: "Êtes-vous sûr de vouloir supprimer",
    deleteBoatIrreversible: "Cette action est irréversible.",
    editBoat: "Modifier le bateau",
    newBoat: "Nouveau bateau",
    sectionBase: "Infos de base",
    sectionModes: "Modes",
    sectionSlots: "Créneaux horaires",
    sectionPayment: "Paiement",
    sectionSeasonal: "Saisonnier",
    boatPhoto: "Photo du bateau",
    photoUploading: "Téléchargement...",
    choosePhoto: "Choisir une photo",
    removePhoto: "Supprimer",
    boatName: "Nom du bateau *",
    boatNameRequired: "Le nom est obligatoire",
    boatModel: "Modèle",
    boatCapacity: "Capacité maximale *",
    boatCapacityRequired: "Entrez une capacité valide",
    boatPort: "Port de départ *",
    boatPortRequired: "Le port de départ est obligatoire",
    boatWeatherZone: "Zone météo",
    boatWeatherZoneOptional: "(facultatif)",
    boatWeatherZoneHint: "Uniquement si les prévisions météo ne fonctionnent pas pour le port indiqué",
    boatNotes: "Notes internes",
    boatNotesPlaceholder: "Notes visibles uniquement par vous...",
    boatShowNotesPublic: "Afficher les notes aux clients sur la page publique",
    boatIsActive: "Bateau actif",
    boatIsActiveDesc: "S'il est désactivé, il n'apparaîtra pas sur la page publique",
    modesSelectAtLeast: "Sélectionnez au moins un mode de réservation",
    modesHint: "Sélectionnez au moins un mode. Vous pouvez en activer plusieurs sur le même bateau.",
    tourGroupLabel: "Tour en Groupe",
    tourGroupDesc: "Prix par personne, plusieurs clients par sortie",
    tourExclusiveLabel: "Tour Exclusif",
    tourExclusiveDesc: "Prix fixe pour le bateau entier",
    tourRentalLabel: "Location",
    tourRentalDesc: "Location sans équipage",
    pricePerPerson: "Prix par personne (€)",
    priceHalfDay: "Demi-journée (€)",
    priceFullDay: "Journée complète (€)",
    priceSunset: "Coucher de soleil (€)",
    skipperAvailable: "Skipper disponible",
    skipperMode: "Mode skipper",
    skipperOnRequest: "Sur demande",
    skipperAlwaysIncluded: "Toujours inclus",
    skipperPrice: "Prix journalier skipper (€)",
    multiDayEnabled: "Activer la location multi-jours",
    multiDayMin: "Durée minimale (jours)",
    multiDayMax: "Durée maximale (jours, vide = illimité)",
    bookingMode: "Mode de réservation",
    bookingModeRequest: "Sur demande (vous confirmez)",
    bookingModeInstant: "Instantanée (auto-confirmée)",
    paymentFull: "Paiement complet",
    paymentDeposit: "Acompte uniquement",
    depositPercent: "% acompte requis",
    seasonalPricing: "Tarifs saisonniers",
    addSeasonalRule: "Ajouter une règle",
    seasonalRuleName: "Nom de la saison",
    seasonalFrom: "Du",
    seasonalTo: "Au",
    seasonalSave: "Enregistrer la règle",
    revenueTitle: "Chiffre d'affaires",
    exportCSV: "Exporter CSV",
    periodDay: "Jour",
    periodWeek: "Semaine",
    periodMonth: "Mois",
    periodYear: "Année",
    typeGroupTourLabel: "Tours en groupe",
    typeExclusiveTourLabel: "Exclusifs",
    typeRentalLabel: "Locations",
    typeOtherLabel: "Autre",
    boatUnknown: "Inconnu",
    csvDate: "Date",
    csvBoat: "Bateau",
    csvCustomer: "Client",
    csvType: "Type",
    csvTotal: "Total",
    csvDeposit: "Acompte",
    csvBalance: "Solde",
    csvPaymentStatus: "Statut de paiement",
    revenueByType: "Récapitulatif par type",
    revenueByBoat: "Chiffre d'affaires par navire",
    revenueBookings: "réservations",
    revenueCollected: "Encaissé",
    revenueTotal: "Total",
    revenueOfTotal: "du total",
    revenueGuests: "passagers",
    revenueDeposits: "Acomptes",
    revenueRemaining: "Solde restant",
    csvExportError: "Erreur lors de l'export",
    settingsTitle: "Paramètres",
    settingsSubtitle: "Profil, paiements, réservations en ligne et notifications.",
    tabProfile: "Profil",
    tabBookings: "Réservations",
    tabPayments: "Paiements",
    tabNotifications: "Notifications",
    tabWeather: "⛈ Météo",
    profileUpdated: "Profil mis à jour avec succès.",
    saveError2: "Erreur lors de l'enregistrement.",
    logoUploadError: "Erreur lors du téléchargement du logo.",
    logoUploading: "Téléchargement",
    changeLogo: "Changer le logo",
    subscriptionActive: "Abonnement actif",
    subscriptionTrial: "Essai en cours",
    subscriptionExpired: "Abonnement expiré",
    personalData: "Données personnelles",
    fieldFirstName: "Prénom",
    fieldLastName: "Nom",
    fieldEmail: "Email",
    fieldPhone: "Téléphone",
    companyData: "Données entreprise",
    companyName: "Nom de l'activité",
    vatNumber: "N° TVA",
    sdiCode: "Code SDI",
    pec: "Email PEC",
    address: "Adresse",
    city: "Ville",
    zip: "Code postal",
    website: "Site web",
    changePassword: "Changer le mot de passe",
    newPassword: "Nouveau mot de passe",
    newPasswordPlaceholder: "Minimum 8 caractères",
    confirmPassword: "Confirmer le mot de passe",
    confirmPasswordPlaceholder: "Répétez le nouveau mot de passe",
    passwordMinLength: "Le nouveau mot de passe doit comporter au moins 8 caractères.",
    passwordMismatch: "Les mots de passe ne correspondent pas.",
    passwordUpdated: "Mot de passe mis à jour.",
    passwordError: "Erreur lors du changement de mot de passe.",
    updatingPassword: "Mise à jour...",
    updatePassword: "Mettre à jour le mot de passe",
    publicBookingLink: "Lien de réservation publique",
    publicBookingLinkDesc: "Partagez ce lien avec vos clients. Ils peuvent voir vos bateaux et réserver directement, 24h/24.",
    featureNotAvailable: "Fonctionnalité non disponible dans votre plan",
    upgradeToEnable: "Passez à un plan supérieur pour activer les réservations en ligne.",
    howToIntegrate: "Comment intégrer sur votre site",
    integrationStep1: "Copiez le lien ci-dessus",
    integrationStep2: "Ajoutez-le comme bouton « Réserver maintenant » sur votre site",
    integrationStep3: "Les clients arrivent sur la page Nautiqo, choisissent le bateau et réservent",
    integrationStep4: "Vous recevez la notification et gérez tout depuis le tableau de bord",
    siteWebLabel: "Site web",
    siteWebDesc: "Ajoutez le lien comme CTA",
    instagramLabel: "Instagram",
    instagramDesc: "Lien en bio ou stories",
    whatsappLabel: "WhatsApp",
    whatsappDesc: "Envoyez aux clients directs",
    copiedBang: "Copié !",
    stripeNotConfigured: "Non configuré",
    stripeVerifying: "En vérification — complétez la configuration",
    stripeActive: "Actif · paiements activés",
    stripeComplete: "Compléter",
    stripeConnect: "Connecter",
    stripeWaiting: "Veuillez patienter",
    stripeCharges: "Prélèvements",
    stripePayouts: "Virements",
    stripeCommission: "Commission",
    stripeEnabled: "✓ Activés",
    stripePending: "En attente",
    absorbFees: "Absorber commission +5%",
    absorbFeesDesc: "Le client paie 5% de plus ; vous recevez le net",
    absorbFeesActive: "Commission +5% activée. Les clients verront le prix majoré.",
    absorbFeesInactive: "Commission +5% désactivée.",
    cancelPolicy: "Politique d'annulation",
    cancelPolicyDesc: "S'applique aux réservations payées avec un acompte en ligne.",
    cancelPolicyFlexible: "Flexible",
    cancelPolicyModerate: "Modérée",
    cancelPolicyStrict: "Stricte",
    cancelPolicyFlexibleRules: "Remboursement 100% jusqu'à 14 jours, 50% jusqu'à 7 jours, pas de remboursement après.",
    cancelPolicyModerateRules: "Remboursement 100% jusqu'à 21 jours, 50% jusqu'à 14 jours, pas de remboursement après.",
    cancelPolicyStrictRules: "Remboursement 100% jusqu'à 30 jours, 50% jusqu'à 21 jours, pas de remboursement après.",
    cancelPolicySaved: "Politique enregistrée.",
    universalClauses: "Clauses universelles : remboursement complet pour mauvais temps et annulation par l'opérateur.",
    stripeHowTitle: "Comment fonctionne Stripe Connect ?",
    stripeHowDesc: "Les paiements sont encaissés directement sur votre compte Stripe. Nautiqo retient une commission (3%) sur chaque transaction réussie. Stripe applique ses propres frais (~1.5%).",
    notifPrefs: "Préférences de notifications",
    notifPrefsDesc: "Choisissez comment recevoir les mises à jour des réservations.",
    notifEmail: "Notifications email",
    notifEmailDesc: "Recevez des emails pour les nouvelles réservations et demandes",
    notifPush: "Notifications push",
    notifPushDesc: "Recevez des notifications push sur l'application mobile",
    weatherPortsTitle: "Prévisions pour vos ports",
    weatherPortsDesc: "Les emplacements sont automatiquement extraits des ports de départ des bateaux.",
    noPortsSet: "Aucun bateau n'a de port de départ configuré",
    weatherPreview: "Aperçu prévisions 7 jours",
    weatherPreviewUnavailable: "Prévisions indisponibles",
    portOK: "Port OK",
    portMissing: "Sans port",
    fleetTitle: "Flotte",
    fleetDesc: "Bateaux qui seront bloqués en cas de mauvais temps, selon leur port.",
    weatherAlertTitle: "Alerte Météo",
    weatherAlertEnabled: "Activer les alertes météo",
    weatherAlertEnabledDesc: "Recevez une notification 3 jours avant si les conditions dépassent les seuils",
    alertThresholds: "Seuils d'alerte",
    alertThresholdsDesc: "L'alerte se déclenche lorsqu'au moins un seuil est dépassé.",
    waveHeight: "Hauteur des vagues",
    windSpeed: "Vitesse du vent",
    autoActionTitle: "Action Automatique",
    autoActionDesc: "Que se passe-t-il quand du mauvais temps est détecté ?",
    askBeforeBlock: "Demander avant de bloquer",
    askBeforeBlockDesc: "Recevez une notification et décidez vous-même",
    autoBlockLabel: "Bloquer automatiquement",
    autoBlockDesc: "Créez immédiatement un blocage pour tous les bateaux et notifiez-vous",
    saveWeatherSettings: "Enregistrer les paramètres météo",
    weatherSettingsSaved: "Paramètres météo enregistrés !",
    invalidWaveHeight: "Hauteur de vague invalide",
    invalidWindSpeed: "Vitesse de vent invalide",
    noPortsForAlert: "Aucun bateau n'a de port de départ. Ajoutez le port aux bateaux pour activer les alertes.",
    weatherSaveError: "Erreur lors de l'enregistrement",
    weatherLoadError: "Impossible de charger les prévisions",
    newBookingTitle: "Nouvelle Réservation",
    step1Title: "Sélectionner la date",
    step2Title: "Sélectionner le bateau et le créneau",
    step3Title: "Sélectionner le client",
    step4Title: "Détails de la réservation",
    step5Title: "Récapitulatif et confirmation",
    timeSlotLabel: "Créneau horaire",
    maxCapacity: "Max.",
    existingCustomer: "Client existant",
    newCustomer: "Nouveau client",
    searchCustomer: "Rechercher par nom, téléphone...",
    noCustomerFound: "Aucun client trouvé",
    noContactInfo: "Aucune info de contact",
    experienceType: "Type d'expérience",
    multiDayRental: "Location multi-jours",
    startDate: "Date de début",
    endDate: "Date de fin *",
    duration: "Durée :",
    minDaysRequired: "Minimum {n} jours requis",
    numPeople: "Nombre de personnes",
    maxPeople: "Max. {n} personnes",
    skipperIncluded: "Skipper inclus",
    skipperCost: "Coût skipper :",
    paymentMethodLabel: "Mode de paiement",
    bookingSourceLabel: "Origine de la réservation",
    customerNotesLabel: "Notes du client",
    internalNotesLabel: "Notes internes",
    depositAmountLabel: "Acompte (€, laisser 0 pour aucun acompte)",
    priceLabel: "Prix (€)",
    suggestedPrice: "Prix suggéré :",
    confirmBooking: "Confirmer la réservation",
    bookingCreating: "Création...",
    nameRequired: "Le prénom et le nom du client sont obligatoires",
    customerRequired: "Sélectionnez ou créez un client",
    bookingError: "Erreur lors de la création de la réservation",
    downloadTitle: "Télécharger Nautiqo",
    downloadDesc: "Gérez réservations, flotte et paiements depuis votre smartphone.",
    downloadIOS: "📱 Télécharger sur l'App Store (iOS)",
    downloadAndroid: "🤖 Télécharger sur Google Play (Android)",
    backToSite: "← Retour au site",
    redirecting: "Redirection en cours…",
  },

  de: {
    loading: "Laden...",
    unknownError: "Unbekannter Fehler",
    save: "Speichern",
    saving: "Speichern...",
    cancel: "Abbrechen",
    delete: "Löschen",
    deleting: "Löschen...",
    edit: "Bearbeiten",
    confirm: "Bestätigen",
    back: "Zurück",
    continua: "Weiter",
    open: "Öffnen",
    copy: "Kopieren",
    copied: "Kopiert",
    update: "Aktualisieren",
    close: "Schließen",
    yes: "Ja",
    no: "Nein",
    fullDay: "Ganzer Tag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    sunset: "Sonnenuntergang",
    statusPending: "Ausstehend",
    statusAccepted: "Akzeptiert",
    statusAwaitingPayment: "Warte auf Zahlung",
    statusConfirmed: "Bestätigt",
    statusCompleted: "Abgeschlossen",
    statusCancelled: "Storniert",
    statusConfirmedBadge: "Bestätigt",
    statusPendingBadge: "Ausstehend",
    statusPaidBadge: "Bezahlt ✓",
    statusConfirmedDeposit: "Bestätigt · Anzahlung",
    payUnpaid: "Nicht bezahlt",
    payPartialDeposit: "Teilanzahlung",
    payDepositReceived: "Anzahlung erhalten",
    payFullyPaid: "Vollständig bezahlt",
    payRefunded: "Erstattet",
    payUnpaidShort: "Nicht bezahlt",
    payDepositReceivedShort: "Anzahlung erhalten",
    payPartialDepositShort: "Teilanzahlung",
    payPaid: "Bezahlt",
    pmCash: "Bargeld",
    pmBankTransfer: "Banküberweisung",
    pmDebitCard: "EC-Karte",
    pmCard: "Karte",
    pmLink: "Link",
    pmStripe: "Stripe",
    pmPaymentLink: "Zahlungslink",
    pmOther: "Sonstiges",
    sourceManual: "Manuell",
    sourceWebsite: "Webseite",
    sourcePhone: "Telefon",
    sourceWhatsApp: "WhatsApp",
    sourceAgency: "Agentur",
    sourceWeb: "Web",
    sourceApp: "App",
    typeGroup: "Gruppenausflug",
    typeExclusive: "Exklusivausflug",
    typeRental: "Miete",
    typeGroupShort: "Gruppe",
    typeExclusiveShort: "Exklusiv",
    loginSubtitle: "Bei Ihrem Konto anmelden",
    emailPlaceholder: "email@beispiel.com",
    rememberMe: "Angemeldet bleiben",
    signingIn: "Anmelden...",
    signIn: "Anmelden",
    noAccount: "Noch kein Konto?",
    registerFree: "Kostenlos registrieren",
    backToHome: "← Zurück zur Startseite",
    charterMgmt: "Charter-Verwaltung",
    navCalendar: "Kalender",
    navBookings: "Buchungen",
    navBoats: "Boote",
    navRevenue: "Umsatz",
    navSettings: "Einstellungen",
    navAccount: "Konto",
    userFallback: "Benutzer",
    logout: "Abmelden",
    greetingMorning: "Guten Morgen",
    greetingAfternoon: "Guten Nachmittag",
    greetingEvening: "Guten Abend",
    charterFallback: "Ihr Charter",
    expiredTitle: "Eingeschränkter Zugang",
    expiredMessage: "Ihre Testphase ist abgelaufen. Aktivieren Sie Ihr Abonnement, um den vollen Zugang wiederherzustellen.",
    activateNow: "Jetzt aktivieren",
    paymentIssueTitle: "Zahlungsproblem",
    paymentIssueMessage: "Aktualisieren Sie Ihre Zahlungsmethode, um den Zugang zu behalten.",
    manage: "Verwalten",
    todayLabel: "Heute",
    toConfirm: "zu bestätigen",
    unpaidLabel: "unbezahlt",
    bookingsToday: "Buchungen heute",
    confirmedCount: "bestätigt",
    fleetToday: "Flotte heute",
    available: "verfügbar",
    occupied: "belegt",
    pendingRequests: "Ausstehende Anfragen",
    viewAll: "Alle anzeigen →",
    bookingLink: "Buchungslink",
    todaysBookings: "Heutige Buchungen",
    noBookingsToday: "Keine Buchungen heute",
    groupTour: "Gruppenausflug",
    bookingsSuffix: "Buch.",
    personsSuffix: "Pers.",
    multiDayUntil: "Mehrtägig: bis zum",
    dayLabel: "Tag",
    daysLabel: "Tage",
    weatherTitle: "Wetter",
    weatherRefresh: "Aktualisieren",
    weatherLoading: "Vorhersage wird geladen…",
    weatherUnavailable: "Vorhersage nicht verfügbar",
    weatherTomorrow: "Morgen",
    weatherClear: "Klar",
    weatherPartlyCloudy: "Teilweise bewölkt",
    weatherCloudy: "Bewölkt",
    weatherFog: "Nebel",
    weatherDrizzle: "Nieselregen",
    weatherRain: "Regen",
    weatherSnow: "Schnee",
    weatherShowers: "Schauer",
    weatherSnowWind: "Schnee und Wind",
    weatherStorm: "Gewitter",
    weatherFullWeek: "Ganze Woche →",
    weather7Days: "7-Tage-Vorhersage",
    guestFallback: "Kunde",
    fieldDate: "Datum",
    fieldTimeSlot: "Zeitfenster",
    fieldBoat: "Boot",
    fieldGuests: "Personen",
    customerNotes: "Kundennotizen:",
    internalNotes: "Interne Notizen:",
    fieldTotal: "Gesamt",
    fieldDeposit: "Anz. erforderlich",
    fieldCollected: "Eingezahlt",
    fieldRemaining: "Restbetrag",
    addPayment: "Zahlung erfassen",
    paymentType: "Typ",
    paymentAmount: "Betrag €",
    paymentMethod: "Methode",
    paymentTypeDeposit: "Anzahlung",
    paymentTypeBalance: "Restbetrag",
    paymentNotes: "Notizen (optional)",
    savePayment: "Zahlung speichern",
    paymentHistory: "Zahlungshistorie",
    editBooking: "Buchung bearbeiten",
    fieldPriceLabel: "Preis €",
    fieldDepositLabel: "Erforderliche Anzahlung €",
    internalNotesPlaceholder: "Interne Notizen",
    saveChanges: "Änderungen speichern",
    confirmDelete: "Löschen bestätigen",
    deleteBooking: "Buchung löschen",
    noPermission: "Sie haben keine Berechtigung für diese Aktion",
    saveError: "Fehler beim Speichern",
    invalidAmount: "Geben Sie einen gültigen Betrag größer als null ein",
    invalidGuests: "Ungültige Personenzahl",
    invalidPrice: "Ungültiger Preis",
    invalidDeposit: "Ungültige Anzahlung",
    depositExceedsTotal: "Die erforderliche Anzahlung darf den Gesamtpreis nicht überschreiten",
    deletePaymentError: "Fehler beim Löschen der Zahlung",
    searchPlaceholder: "Kunde, Boot suchen...",
    filterAll: "Alle",
    filterUpcoming: "Bevorstehend",
    filterPast: "Vergangen",
    listView: "Liste",
    calendarView: "Kalender",
    accept: "Annehmen",
    reject: "Ablehnen",
    complete: "Abgeschlossen",
    noContact: "Keine Kontaktdaten",
    noBookingsFound: "Keine Buchungen gefunden",
    requestsTitle: "Anfragen",
    noRequestsPending: "Keine ausstehenden Anfragen",
    newRequest: "Neue Anfrage",
    boatsTitle: "Boote",
    addBoat: "Boot hinzufügen",
    onlyActiveBoats: "Nur aktive Boote",
    noBoats: "Noch keine Boote",
    addFirstBoat: "Fügen Sie Ihr erstes Boot hinzu",
    boatActive: "AKTIV",
    boatInactive: "INAKTIV",
    deactivate: "Deaktivieren",
    activate: "Aktivieren",
    deleteBoat: "Boot löschen",
    deleteBoatConfirm: "Möchten Sie wirklich löschen",
    deleteBoatIrreversible: "Diese Aktion kann nicht rückgängig gemacht werden.",
    editBoat: "Boot bearbeiten",
    newBoat: "Neues Boot",
    sectionBase: "Grundinfo",
    sectionModes: "Modi",
    sectionSlots: "Zeitfenster",
    sectionPayment: "Zahlung",
    sectionSeasonal: "Saisonal",
    boatPhoto: "Bootsfoto",
    photoUploading: "Hochladen...",
    choosePhoto: "Foto wählen",
    removePhoto: "Entfernen",
    boatName: "Bootsname *",
    boatNameRequired: "Name ist erforderlich",
    boatModel: "Modell",
    boatCapacity: "Maximale Kapazität *",
    boatCapacityRequired: "Geben Sie eine gültige Kapazität ein",
    boatPort: "Abfahrtshafen *",
    boatPortRequired: "Abfahrtshafen ist erforderlich",
    boatWeatherZone: "Wetterzone",
    boatWeatherZoneOptional: "(optional)",
    boatWeatherZoneHint: "Nur wenn Wettervorhersagen für den angegebenen Hafen nicht funktionieren",
    boatNotes: "Interne Notizen",
    boatNotesPlaceholder: "Nur für Sie sichtbare Notizen...",
    boatShowNotesPublic: "Notizen auf der öffentlichen Seite anzeigen",
    boatIsActive: "Boot aktiv",
    boatIsActiveDesc: "Wenn deaktiviert, erscheint es nicht auf der öffentlichen Seite",
    modesSelectAtLeast: "Wählen Sie mindestens einen Buchungsmodus",
    modesHint: "Wählen Sie mindestens einen Modus. Sie können mehrere für dasselbe Boot aktivieren.",
    tourGroupLabel: "Gruppenausflug",
    tourGroupDesc: "Preis pro Person, mehrere Gäste pro Ausflug",
    tourExclusiveLabel: "Exklusivausflug",
    tourExclusiveDesc: "Festpreis für das gesamte Boot",
    tourRentalLabel: "Miete",
    tourRentalDesc: "Bareboat-Charter",
    pricePerPerson: "Preis pro Person (€)",
    priceHalfDay: "Halbtag (€)",
    priceFullDay: "Ganzer Tag (€)",
    priceSunset: "Sonnenuntergang (€)",
    skipperAvailable: "Skipper verfügbar",
    skipperMode: "Skipper-Modus",
    skipperOnRequest: "Auf Anfrage",
    skipperAlwaysIncluded: "Immer inbegriffen",
    skipperPrice: "Skipper-Tagespreis (€)",
    multiDayEnabled: "Mehrtägige Miete aktivieren",
    multiDayMin: "Mindestdauer (Tage)",
    multiDayMax: "Höchstdauer (Tage, leer = unbegrenzt)",
    bookingMode: "Buchungsmodus",
    bookingModeRequest: "Auf Anfrage (Sie bestätigen)",
    bookingModeInstant: "Sofort (auto-bestätigt)",
    paymentFull: "Vollständige Zahlung",
    paymentDeposit: "Nur Anzahlung",
    depositPercent: "Anzahlungsprozentsatz",
    seasonalPricing: "Saisonale Preise",
    addSeasonalRule: "Regel hinzufügen",
    seasonalRuleName: "Saisonname",
    seasonalFrom: "Von",
    seasonalTo: "Bis",
    seasonalSave: "Regel speichern",
    revenueTitle: "Umsatz",
    exportCSV: "CSV exportieren",
    periodDay: "Tag",
    periodWeek: "Woche",
    periodMonth: "Monat",
    periodYear: "Jahr",
    typeGroupTourLabel: "Gruppenausflüge",
    typeExclusiveTourLabel: "Exklusiv",
    typeRentalLabel: "Mieten",
    typeOtherLabel: "Sonstiges",
    boatUnknown: "Unbekannt",
    csvDate: "Datum",
    csvBoat: "Boot",
    csvCustomer: "Kunde",
    csvType: "Typ",
    csvTotal: "Gesamt",
    csvDeposit: "Anzahlung",
    csvBalance: "Restbetrag",
    csvPaymentStatus: "Zahlungsstatus",
    revenueByType: "Übersicht nach Typ",
    revenueByBoat: "Umsatz pro Schiff",
    revenueBookings: "Buchungen",
    revenueCollected: "Eingezahlt",
    revenueTotal: "Gesamt",
    revenueOfTotal: "vom Gesamt",
    revenueGuests: "Gäste",
    revenueDeposits: "Anzahlungen",
    revenueRemaining: "Restbetrag",
    csvExportError: "Fehler beim Export",
    settingsTitle: "Einstellungen",
    settingsSubtitle: "Profil, Zahlungen, Online-Buchungen und Benachrichtigungen.",
    tabProfile: "Profil",
    tabBookings: "Buchungen",
    tabPayments: "Zahlungen",
    tabNotifications: "Benachrichtigungen",
    tabWeather: "⛈ Wetter",
    profileUpdated: "Profil erfolgreich aktualisiert.",
    saveError2: "Fehler beim Speichern.",
    logoUploadError: "Fehler beim Hochladen des Logos.",
    logoUploading: "Hochladen",
    changeLogo: "Logo ändern",
    subscriptionActive: "Abonnement aktiv",
    subscriptionTrial: "Testphase aktiv",
    subscriptionExpired: "Abonnement abgelaufen",
    personalData: "Persönliche Daten",
    fieldFirstName: "Vorname",
    fieldLastName: "Nachname",
    fieldEmail: "E-Mail",
    fieldPhone: "Telefon",
    companyData: "Unternehmensdaten",
    companyName: "Unternehmensname",
    vatNumber: "USt-IdNr.",
    sdiCode: "SDI-Code",
    pec: "PEC-E-Mail",
    address: "Adresse",
    city: "Stadt",
    zip: "Postleitzahl",
    website: "Webseite",
    changePassword: "Passwort ändern",
    newPassword: "Neues Passwort",
    newPasswordPlaceholder: "Mindestens 8 Zeichen",
    confirmPassword: "Passwort bestätigen",
    confirmPasswordPlaceholder: "Neues Passwort wiederholen",
    passwordMinLength: "Das neue Passwort muss mindestens 8 Zeichen lang sein.",
    passwordMismatch: "Die Passwörter stimmen nicht überein.",
    passwordUpdated: "Passwort aktualisiert.",
    passwordError: "Fehler beim Ändern des Passworts.",
    updatingPassword: "Aktualisieren...",
    updatePassword: "Passwort aktualisieren",
    publicBookingLink: "Öffentlicher Buchungslink",
    publicBookingLinkDesc: "Teilen Sie diesen Link mit Ihren Kunden. Sie können Ihre Boote sehen und direkt buchen, 24/7.",
    featureNotAvailable: "Funktion in Ihrem Plan nicht verfügbar",
    upgradeToEnable: "Upgraden Sie Ihr Abonnement, um Online-Buchungen zu aktivieren.",
    howToIntegrate: "So integrieren Sie es auf Ihrer Website",
    integrationStep1: "Kopieren Sie den obigen Link",
    integrationStep2: "Fügen Sie ihn als \"Jetzt buchen\"-Schaltfläche auf Ihrer Website hinzu",
    integrationStep3: "Kunden landen auf der Nautiqo-Seite, wählen ein Boot und buchen",
    integrationStep4: "Sie erhalten die Benachrichtigung und verwalten alles vom Dashboard aus",
    siteWebLabel: "Website",
    siteWebDesc: "Link als CTA hinzufügen",
    instagramLabel: "Instagram",
    instagramDesc: "Link in Bio oder Stories",
    whatsappLabel: "WhatsApp",
    whatsappDesc: "An direkte Kunden senden",
    copiedBang: "Kopiert!",
    stripeNotConfigured: "Nicht konfiguriert",
    stripeVerifying: "In Prüfung — Konfiguration abschließen",
    stripeActive: "Aktiv · Zahlungen aktiviert",
    stripeComplete: "Abschließen",
    stripeConnect: "Verbinden",
    stripeWaiting: "Bitte warten",
    stripeCharges: "Lastschriften",
    stripePayouts: "Auszahlungen",
    stripeCommission: "Provision",
    stripeEnabled: "✓ Aktiviert",
    stripePending: "Ausstehend",
    absorbFees: "Gebühr +5% übernehmen",
    absorbFeesDesc: "Kunde zahlt 5% mehr; Sie erhalten den Nettobetrag",
    absorbFeesActive: "+5% Gebühr aktiviert. Kunden sehen den erhöhten Preis.",
    absorbFeesInactive: "+5% Gebühr deaktiviert.",
    cancelPolicy: "Stornierungsbedingungen",
    cancelPolicyDesc: "Gilt für Buchungen, die mit einer Online-Anzahlung bezahlt wurden.",
    cancelPolicyFlexible: "Flexibel",
    cancelPolicyModerate: "Moderat",
    cancelPolicyStrict: "Streng",
    cancelPolicyFlexibleRules: "100% Erstattung bis 14 Tage, 50% bis 7 Tage, danach keine Erstattung.",
    cancelPolicyModerateRules: "100% Erstattung bis 21 Tage, 50% bis 14 Tage, danach keine Erstattung.",
    cancelPolicyStrictRules: "100% Erstattung bis 30 Tage, 50% bis 21 Tage, danach keine Erstattung.",
    cancelPolicySaved: "Richtlinie gespeichert.",
    universalClauses: "Universelle Klauseln: vollständige Erstattung bei schlechtem Wetter und Stornierung durch den Betreiber.",
    stripeHowTitle: "Wie funktioniert Stripe Connect?",
    stripeHowDesc: "Zahlungen werden direkt auf Ihr Stripe-Konto eingezogen. Nautiqo behält eine Provision (3%) bei jeder erfolgreichen Transaktion. Stripe berechnet seine eigenen Gebühren (~1.5%).",
    notifPrefs: "Benachrichtigungseinstellungen",
    notifPrefsDesc: "Wählen Sie, wie Sie Buchungsaktualisierungen erhalten möchten.",
    notifEmail: "E-Mail-Benachrichtigungen",
    notifEmailDesc: "E-Mails für neue Buchungen und Anfragen erhalten",
    notifPush: "Push-Benachrichtigungen",
    notifPushDesc: "Push-Benachrichtigungen in der mobilen App erhalten",
    weatherPortsTitle: "Vorhersagen für Ihre Häfen",
    weatherPortsDesc: "Positionen werden automatisch aus den Abfahrtshäfen der Boote übernommen.",
    noPortsSet: "Kein Boot hat einen Abfahrtshafen konfiguriert",
    weatherPreview: "7-Tage-Vorschau",
    weatherPreviewUnavailable: "Vorhersage nicht verfügbar",
    portOK: "Hafen OK",
    portMissing: "Kein Hafen",
    fleetTitle: "Flotte",
    fleetDesc: "Boote, die bei schlechtem Wetter gesperrt werden, basierend auf ihrem Hafen.",
    weatherAlertTitle: "Schlechtwetter-Alarm",
    weatherAlertEnabled: "Wetterwarnungen aktivieren",
    weatherAlertEnabledDesc: "3 Tage vorher benachrichtigt werden, wenn Bedingungen Schwellenwerte überschreiten",
    alertThresholds: "Alarmschwellenwerte",
    alertThresholdsDesc: "Der Alarm wird ausgelöst, wenn mindestens ein Schwellenwert überschritten wird.",
    waveHeight: "Wellenhöhe",
    windSpeed: "Windgeschwindigkeit",
    autoActionTitle: "Automatische Aktion",
    autoActionDesc: "Was passiert, wenn schlechtes Wetter erkannt wird?",
    askBeforeBlock: "Vor dem Sperren fragen",
    askBeforeBlockDesc: "Benachrichtigung erhalten und selbst entscheiden",
    autoBlockLabel: "Automatisch sperren",
    autoBlockDesc: "Sofort eine Sperre für alle Boote erstellen und benachrichtigen",
    saveWeatherSettings: "Wettereinstellungen speichern",
    weatherSettingsSaved: "Wettereinstellungen gespeichert!",
    invalidWaveHeight: "Ungültige Wellenhöhe",
    invalidWindSpeed: "Ungültige Windgeschwindigkeit",
    noPortsForAlert: "Kein Boot hat einen Abfahrtshafen. Fügen Sie den Hafen zu den Booten hinzu, um Warnungen zu aktivieren.",
    weatherSaveError: "Fehler beim Speichern",
    weatherLoadError: "Vorhersage kann nicht geladen werden",
    newBookingTitle: "Neue Buchung",
    step1Title: "Datum auswählen",
    step2Title: "Boot und Zeit auswählen",
    step3Title: "Kunde auswählen",
    step4Title: "Buchungsdetails",
    step5Title: "Zusammenfassung & Bestätigung",
    timeSlotLabel: "Zeitfenster",
    maxCapacity: "Max.",
    existingCustomer: "Bestehender Kunde",
    newCustomer: "Neuer Kunde",
    searchCustomer: "Nach Name, Telefon suchen...",
    noCustomerFound: "Keine Kunden gefunden",
    noContactInfo: "Keine Kontaktdaten",
    experienceType: "Erlebnistyp",
    multiDayRental: "Mehrtägige Miete",
    startDate: "Startdatum",
    endDate: "Enddatum *",
    duration: "Dauer:",
    minDaysRequired: "Mindestens {n} Tage erforderlich",
    numPeople: "Anzahl Personen",
    maxPeople: "Max. {n} Personen",
    skipperIncluded: "Skipper inbegriffen",
    skipperCost: "Skipperkosten:",
    paymentMethodLabel: "Zahlungsmethode",
    bookingSourceLabel: "Buchungsquelle",
    customerNotesLabel: "Kundennotizen",
    internalNotesLabel: "Interne Notizen",
    depositAmountLabel: "Anzahlung (€, 0 lassen für keine Anzahlung)",
    priceLabel: "Preis (€)",
    suggestedPrice: "Vorgeschlagener Preis:",
    confirmBooking: "Buchung bestätigen",
    bookingCreating: "Erstellen...",
    nameRequired: "Vor- und Nachname des Kunden sind erforderlich",
    customerRequired: "Wählen oder erstellen Sie einen Kunden",
    bookingError: "Fehler beim Erstellen der Buchung",
    downloadTitle: "Nautiqo herunterladen",
    downloadDesc: "Verwalten Sie Buchungen, Flotte und Zahlungen von Ihrem Smartphone.",
    downloadIOS: "📱 Im App Store herunterladen (iOS)",
    downloadAndroid: "🤖 Bei Google Play herunterladen (Android)",
    backToSite: "← Zurück zur Website",
    redirecting: "Weiterleitung…",
  },
};

export default adminTranslations;
